// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   DOCTOR TELECONSULTATION
   Design tokens, layout, video, notes workspace, feedback states.
   ========================================================================== */

.doctor-call-page {
  --dc-primary: #0f766e;
  --dc-primary-strong: #0b5f59;
  --dc-primary-soft: #e4f4f1;
  --dc-primary-tint: #f2faf8;

  --dc-ink: #10202e;
  --dc-ink-soft: #33475b;
  --dc-muted: #5a6b7c;

  --dc-line: #dfe8ec;
  --dc-line-strong: #c6d5dd;

  --dc-surface: #ffffff;
  --dc-surface-muted: #f6f9fa;
  --dc-bg: #eef4f4;

  --dc-success: #147a4b;
  --dc-success-bg: #e6f6ee;
  --dc-warning: #8a5a00;
  --dc-warning-bg: #fff5dc;
  --dc-danger: #b42318;
  --dc-danger-strong: #d92d20;
  --dc-danger-bg: #fdecec;
  --dc-info: #175cd3;
  --dc-info-bg: #eef4ff;

  --dc-space-1: 4px;
  --dc-space-2: 8px;
  --dc-space-3: 12px;
  --dc-space-4: 16px;
  --dc-space-5: 20px;
  --dc-space-6: 24px;
  --dc-space-7: 32px;
  --dc-space-8: 40px;

  --dc-radius-sm: 8px;
  --dc-radius-md: 12px;
  --dc-radius-lg: 16px;
  --dc-radius-xl: 22px;
  --dc-radius-pill: 999px;

  --dc-shadow-sm: 0 1px 2px rgba(16, 32, 46, 0.06);
  --dc-shadow-md: 0 8px 24px rgba(16, 32, 46, 0.08);
  --dc-shadow-lg: 0 24px 60px rgba(16, 32, 46, 0.2);

  --dc-text-xs: 11px;
  --dc-text-sm: 12px;
  --dc-text-base: 13px;
  --dc-text-md: 14px;
  --dc-text-lg: 16px;
  --dc-text-xl: 18px;
  --dc-text-2xl: 22px;
  --dc-text-3xl: 28px;

  --dc-transition: 160ms ease;
  --dc-focus-ring: 0 0 0 3px rgba(15, 118, 110, 0.24);

  min-height: 100vh;
  padding: var(--dc-space-5) clamp(14px, 3.2vw, 44px) var(--dc-space-8);
  color: var(--dc-ink);
  background-color: var(--dc-bg);
  background-image:
    radial-gradient(1100px 480px at 8% -12%, rgba(15, 118, 110, 0.1), transparent 62%),
    radial-gradient(900px 420px at 100% 0, rgba(23, 92, 211, 0.05), transparent 60%);
  font-family: "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, Arial, sans-serif;
  font-size: var(--dc-text-md);
  line-height: 1.5;
}

.doctor-call-page *,
.doctor-call-page *::before,
.doctor-call-page *::after {
  box-sizing: border-box;
}

.doctor-call-page button {
  font: inherit;
  cursor: pointer;
}

.doctor-call-page :is(button, input, textarea, [tabindex]):focus-visible {
  outline: 3px solid rgba(15, 118, 110, 0.42);
  outline-offset: 2px;
}

.doctor-call-page h1,
.doctor-call-page h2,
.doctor-call-page h3,
.doctor-call-page h4,
.doctor-call-page p,
.doctor-call-page dl,
.doctor-call-page dd {
  overflow-wrap: anywhere;
}

.doctor-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

.doctor-eyebrow {
  margin: 0 0 2px;
  color: var(--dc-primary);
  font-size: var(--dc-text-xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

/* --------------------------------------------------------------------------
   Shared controls
   -------------------------------------------------------------------------- */

.doctor-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--dc-space-2);
  min-height: 44px;
  padding: 0 var(--dc-space-4);
  border: 1px solid transparent;
  border-radius: 10px;
  color: #ffffff;
  background: var(--dc-primary);
  font-size: var(--dc-text-base);
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  transition:
    background-color var(--dc-transition),
    border-color var(--dc-transition),
    box-shadow var(--dc-transition),
    transform var(--dc-transition);
}

.doctor-button svg {
  width: 17px;
  height: 17px;
  flex-shrink: 0;
}

.doctor-button:hover:not(:disabled) {
  background: var(--dc-primary-strong);
  box-shadow: 0 6px 16px rgba(15, 118, 110, 0.22);
}

.doctor-button:active:not(:disabled) {
  transform: translateY(1px);
}

.doctor-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.doctor-button--secondary {
  color: var(--dc-ink-soft);
  background: var(--dc-surface);
  border-color: var(--dc-line-strong);
}

.doctor-button--secondary:hover:not(:disabled) {
  background: var(--dc-surface-muted);
  box-shadow: var(--dc-shadow-sm);
}

.doctor-button--danger {
  color: #ffffff;
  background: var(--dc-danger-strong);
}

.doctor-button--danger:hover:not(:disabled) {
  background: #b42318;
  box-shadow: 0 6px 16px rgba(217, 45, 32, 0.24);
}

.doctor-button--lg {
  min-height: 50px;
  padding: 0 var(--dc-space-6);
  font-size: var(--dc-text-md);
}

.doctor-button-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: doctor-spin 0.7s linear infinite;
}

.doctor-button--secondary .doctor-button-spinner {
  border-color: rgba(15, 118, 110, 0.24);
  border-top-color: var(--dc-primary);
}

.doctor-spinner-sm {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  border: 2px solid var(--dc-primary-soft);
  border-top-color: var(--dc-primary);
  border-radius: 50%;
  animation: doctor-spin 0.7s linear infinite;
}

.doctor-page-spinner {
  width: 38px;
  height: 38px;
  border: 3px solid var(--dc-line);
  border-top-color: var(--dc-primary);
  border-radius: 50%;
  animation: doctor-spin 0.8s linear infinite;
}

@keyframes doctor-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes doctor-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(226, 168, 47, 0.35);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(226, 168, 47, 0);
  }
}

@keyframes doctor-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes doctor-pop-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes doctor-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* --------------------------------------------------------------------------
   Header
   -------------------------------------------------------------------------- */

.doctor-page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--dc-space-4);
  max-width: 1600px;
  margin: 0 auto var(--dc-space-4);
}

.doctor-page-heading {
  display: flex;
  align-items: flex-start;
  gap: var(--dc-space-3);
  min-width: 0;
}

.doctor-page-heading h1 {
  margin: 0;
  font-size: var(--dc-text-2xl);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.01em;
}

.doctor-page-subtitle {
  margin: var(--dc-space-1) 0 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-base);
}

.doctor-page-subtitle strong {
  color: var(--dc-ink-soft);
}

.doctor-back-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 36px;
  margin-top: 2px;
  padding: 0 10px;
  border: 1px solid transparent;
  border-radius: 9px;
  color: var(--dc-muted);
  background: transparent;
  font-size: var(--dc-text-sm);
  font-weight: 650;
}

.doctor-back-button svg {
  width: 16px;
  height: 16px;
}

.doctor-back-button:hover {
  color: var(--dc-ink);
  background: var(--dc-surface);
  border-color: var(--dc-line);
}

.doctor-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  padding: 7px 12px;
  border-radius: var(--dc-radius-pill);
  font-size: var(--dc-text-xs);
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.doctor-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.doctor-status-badge.is-ongoing {
  color: var(--dc-success);
  background: var(--dc-success-bg);
}

.doctor-status-badge.is-waiting {
  color: var(--dc-warning);
  background: var(--dc-warning-bg);
}

/* --------------------------------------------------------------------------
   Alerts
   -------------------------------------------------------------------------- */

.doctor-alert {
  display: flex;
  align-items: flex-start;
  gap: var(--dc-space-2);
  padding: 10px 12px;
  border: 1px solid transparent;
  border-radius: 10px;
  font-size: var(--dc-text-base);
  line-height: 1.5;
}

.doctor-alert svg {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  flex-shrink: 0;
}

.doctor-alert--danger {
  color: var(--dc-danger);
  background: var(--dc-danger-bg);
  border-color: #f7cdc9;
}

.doctor-alert--warning {
  color: var(--dc-warning);
  background: var(--dc-warning-bg);
  border-color: #f2dfae;
}

.doctor-alert--info {
  color: var(--dc-info);
  background: var(--dc-info-bg);
  border-color: #cddcf8;
}

.doctor-alert--success {
  color: var(--dc-success);
  background: var(--dc-success-bg);
  border-color: #c3e8d5;
}

.doctor-call-page > .doctor-alert {
  max-width: 1600px;
  margin: 0 auto var(--dc-space-3);
}

/* --------------------------------------------------------------------------
   Patient summary bar
   -------------------------------------------------------------------------- */

.doctor-patient-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--dc-space-3);
  padding: 12px 14px;
  background: var(--dc-surface);
  border: 1px solid var(--dc-line);
  border-radius: var(--dc-radius-lg);
  box-shadow: var(--dc-shadow-sm);
}

.doctor-patient-identity {
  display: flex;
  align-items: center;
  gap: var(--dc-space-3);
  min-width: 0;
}

.doctor-patient-avatar {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 14px;
  color: var(--dc-primary);
  background: var(--dc-primary-soft);
  font-size: var(--dc-text-lg);
  font-weight: 800;
  letter-spacing: 0.02em;
}

.doctor-patient-identity-text {
  min-width: 0;
}

.doctor-patient-identity-text h2 {
  margin: 0;
  font-size: var(--dc-text-lg);
  font-weight: 700;
  line-height: 1.25;
}

.doctor-patient-identity-text p {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px 7px;
  margin: 3px 0 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-sm);
}

.doctor-patient-flags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.doctor-flag {
  display: inline-flex;
  align-items: flex-start;
  gap: 5px;
  max-width: 100%;
  padding: 5px 10px;
  border: 1px solid transparent;
  border-radius: var(--dc-radius-pill);
  font-size: var(--dc-text-xs);
  font-weight: 700;
  line-height: 1.4;
}

.doctor-flag svg {
  width: 13px;
  height: 13px;
  flex-shrink: 0;
}

.doctor-flag--danger {
  color: var(--dc-danger);
  background: var(--dc-danger-bg);
  border-color: #f7cdc9;
}

.doctor-flag--neutral {
  color: var(--dc-muted);
  background: var(--dc-surface-muted);
  border-color: var(--dc-line);
}

.doctor-flags-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--dc-space-2);
}

/* --------------------------------------------------------------------------
   Waiting state
   -------------------------------------------------------------------------- */

.doctor-waiting-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: var(--dc-space-4);
  align-items: start;
  max-width: 1600px;
  margin: 0 auto;
}

.doctor-waiting-main {
  display: flex;
  flex-direction: column;
  gap: var(--dc-space-4);
  min-width: 0;
}

.doctor-info-card,
.doctor-waiting-card,
.doctor-video-panel,
.doctor-notes-panel {
  min-width: 0;
  background: var(--dc-surface);
  border: 1px solid var(--dc-line);
  border-radius: var(--dc-radius-lg);
  box-shadow: var(--dc-shadow-md);
}

.doctor-info-card {
  padding: var(--dc-space-5);
}

.doctor-card-heading,
.doctor-tab-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--dc-space-3);
  margin-bottom: var(--dc-space-4);
}

.doctor-card-heading h2,
.doctor-card-heading h3,
.doctor-tab-heading h2 {
  margin: 0;
  font-size: var(--dc-text-xl);
  font-weight: 700;
  line-height: 1.25;
}

.doctor-tab-heading p,
.doctor-card-heading p {
  margin: 3px 0 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-base);
}

.doctor-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px 20px;
  margin: 0;
}

.doctor-info-grid dt {
  margin-bottom: 3px;
  color: var(--dc-muted);
  font-size: var(--dc-text-xs);
  font-weight: 650;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.doctor-info-grid dd {
  margin: 0;
  color: var(--dc-ink-soft);
  font-size: var(--dc-text-base);
  font-weight: 650;
}

.doctor-waiting-card {
  position: sticky;
  top: var(--dc-space-4);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--dc-space-2);
  padding: var(--dc-space-7) var(--dc-space-5);
  text-align: center;
  background:
    radial-gradient(420px 220px at 50% 0, rgba(15, 118, 110, 0.1), transparent 70%),
    var(--dc-surface);
}

.doctor-waiting-icon {
  display: grid;
  place-items: center;
  width: 58px;
  height: 58px;
  margin-bottom: var(--dc-space-2);
  border-radius: 18px;
  color: var(--dc-primary);
  background: var(--dc-primary-soft);
}

.doctor-waiting-icon svg {
  width: 26px;
  height: 26px;
}

.doctor-waiting-card h2 {
  margin: 0;
  font-size: var(--dc-text-xl);
}

.doctor-waiting-card > p:not(.doctor-eyebrow) {
  margin: 0 0 var(--dc-space-3);
  max-width: 300px;
  color: var(--dc-muted);
  font-size: var(--dc-text-base);
  line-height: 1.6;
}

.doctor-waiting-card .doctor-button {
  width: 100%;
}

/* --------------------------------------------------------------------------
   Live layout
   -------------------------------------------------------------------------- */

.doctor-live-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.12fr) minmax(0, 1fr);
  gap: var(--dc-space-4);
  align-items: start;
  max-width: 1600px;
  margin: 0 auto;
}

.doctor-live-sidebar {
  position: sticky;
  top: var(--dc-space-4);
  display: flex;
  flex-direction: column;
  gap: var(--dc-space-3);
  min-width: 0;
}

/* --------------------------------------------------------------------------
   Video
   -------------------------------------------------------------------------- */

.doctor-video-panel {
  padding: var(--dc-space-3);
}

.doctor-video-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--dc-space-3);
  padding: 2px 2px var(--dc-space-3);
}

.doctor-video-header h2 {
  margin: 0;
  font-size: var(--dc-text-lg);
  font-weight: 700;
  line-height: 1.25;
}

.doctor-video-header p {
  margin: 2px 0 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-sm);
}

.doctor-connection-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 6px 10px;
  border-radius: var(--dc-radius-pill);
  font-size: var(--dc-text-xs);
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.doctor-connection-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.doctor-connection-badge.is-success {
  color: var(--dc-success);
  background: var(--dc-success-bg);
}

.doctor-connection-badge.is-pending {
  color: var(--dc-warning);
  background: var(--dc-warning-bg);
}

.doctor-connection-badge.is-pending .doctor-connection-dot {
  animation: doctor-pulse 1.8s ease-in-out infinite;
}

.doctor-connection-badge.is-warning {
  color: #9a3412;
  background: #ffedd5;
}

.doctor-connection-badge.is-warning .doctor-connection-dot {
  animation: doctor-pulse 1.2s ease-in-out infinite;
}

.doctor-video-stage {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  border-radius: var(--dc-radius-md);
  background: #0b1f2a;
  isolation: isolate;
}

.doctor-remote-video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #0b1f2a;
}

.doctor-video-placeholder {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: var(--dc-space-5);
  text-align: center;
  color: #e8f1f3;
  background:
    radial-gradient(420px 260px at 50% 12%, rgba(15, 118, 110, 0.35), transparent 70%),
    rgba(7, 20, 28, 0.86);
}

.doctor-video-placeholder strong {
  font-size: var(--dc-text-lg);
  font-weight: 650;
}

.doctor-video-placeholder > span:last-child {
  max-width: 320px;
  color: #a9bcc6;
  font-size: var(--dc-text-sm);
}

.doctor-video-pulse {
  display: grid;
  place-items: center;
  width: 58px;
  height: 58px;
  margin-bottom: var(--dc-space-2);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  color: #d9eef0;
  background: rgba(15, 118, 110, 0.32);
  animation: doctor-pulse 2.4s ease-out infinite;
}

.doctor-video-pulse svg {
  width: 25px;
  height: 25px;
}

.doctor-video-overlay-top {
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--dc-space-2);
  pointer-events: none;
}

.doctor-call-timer,
.doctor-room-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--dc-radius-pill);
  color: #ffffff;
  background: rgba(7, 20, 28, 0.62);
  font-size: var(--dc-text-xs);
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  backdrop-filter: blur(6px);
}

.doctor-call-timer svg {
  width: 13px;
  height: 13px;
}

.doctor-room-chip {
  max-width: 55%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doctor-local-video-wrap {
  position: absolute;
  right: 12px;
  bottom: 12px;
  width: clamp(104px, 26%, 178px);
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border: 2px solid rgba(255, 255, 255, 0.82);
  border-radius: var(--dc-radius-md);
  background: #1b2f3b;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
}

.doctor-local-video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scaleX(-1);
}

.doctor-local-video-label {
  position: absolute;
  left: 6px;
  bottom: 6px;
  padding: 2px 7px;
  border-radius: var(--dc-radius-pill);
  color: #ffffff;
  background: rgba(7, 20, 28, 0.65);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.doctor-camera-off {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #dbe7ea;
  background: #1b2f3b;
  font-size: var(--dc-text-xs);
}

.doctor-camera-off svg {
  width: 20px;
  height: 20px;
}

.doctor-video-panel > .doctor-alert {
  margin-top: var(--dc-space-3);
}

.doctor-media-retry {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--dc-space-3);
  margin-top: var(--dc-space-3);
  padding: var(--dc-space-3);
  border: 1px dashed var(--dc-line-strong);
  border-radius: 10px;
  background: var(--dc-surface-muted);
}

.doctor-media-retry p {
  flex: 1 1 240px;
  margin: 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-sm);
  line-height: 1.5;
}

/* --------------------------------------------------------------------------
   Call controls
   -------------------------------------------------------------------------- */

.doctor-call-controls {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: var(--dc-space-6);
  padding: var(--dc-space-4) 0 var(--dc-space-1);
}

.doctor-control {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.doctor-control-button {
  position: relative;
  display: grid;
  place-items: center;
  width: 56px;
  height: 56px;
  min-height: 56px;
  padding: 0;
  border: 1px solid var(--dc-line-strong);
  border-radius: 50%;
  color: var(--dc-ink-soft);
  background: var(--dc-surface-muted);
  transition:
    background-color var(--dc-transition),
    border-color var(--dc-transition),
    color var(--dc-transition),
    transform var(--dc-transition),
    box-shadow var(--dc-transition);
}

.doctor-control-button svg {
  width: 22px;
  height: 22px;
}

.doctor-control-button:hover:not(:disabled) {
  border-color: var(--dc-primary);
  color: var(--dc-primary);
  background: var(--dc-primary-soft);
  transform: translateY(-1px);
  box-shadow: var(--dc-shadow-sm);
}

.doctor-control-button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.doctor-control-button.is-off {
  border-color: #f2c9c6;
  color: var(--dc-danger);
  background: var(--dc-danger-bg);
}

.doctor-control-button--danger {
  border-color: var(--dc-danger-strong);
  color: #ffffff;
  background: var(--dc-danger-strong);
  box-shadow: 0 6px 16px rgba(217, 45, 32, 0.26);
}

.doctor-control-button--danger:hover:not(:disabled) {
  border-color: #b42318;
  color: #ffffff;
  background: #b42318;
  box-shadow: 0 8px 20px rgba(217, 45, 32, 0.32);
}

.doctor-control-button::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 9px);
  left: 50%;
  padding: 5px 9px;
  border-radius: 6px;
  color: #ffffff;
  background: var(--dc-ink);
  font-size: var(--dc-text-xs);
  font-weight: 600;
  white-space: nowrap;
  opacity: 0;
  transform: translate(-50%, 3px);
  pointer-events: none;
  transition: opacity var(--dc-transition), transform var(--dc-transition);
}

.doctor-control-button:hover::after,
.doctor-control-button:focus-visible::after {
  opacity: 1;
  transform: translate(-50%, 0);
}

.doctor-control-caption {
  color: var(--dc-muted);
  font-size: var(--dc-text-xs);
  font-weight: 600;
}

.doctor-joining-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--dc-space-2);
  margin: var(--dc-space-2) 0 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-sm);
}

.doctor-call-page > .doctor-alert,
.doctor-page-header,
.doctor-live-layout,
.doctor-waiting-layout {
  width: 100%;
}

/* --------------------------------------------------------------------------
   Notes workspace: tabs
   -------------------------------------------------------------------------- */

.doctor-notes-panel {
  display: flex;
  flex-direction: column;
  gap: var(--dc-space-3);
  padding: var(--dc-space-3);
}

.doctor-tabs {
  position: sticky;
  top: var(--dc-space-4);
  z-index: 5;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 4px;
  padding: 4px;
  border: 1px solid var(--dc-line);
  border-radius: var(--dc-radius-md);
  background: var(--dc-surface-muted);
}

.doctor-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 42px;
  padding: 0 8px;
  border: 0;
  border-radius: 9px;
  color: var(--dc-muted);
  background: transparent;
  font-size: var(--dc-text-sm);
  font-weight: 650;
  white-space: nowrap;
  transition:
    background-color var(--dc-transition),
    color var(--dc-transition),
    box-shadow var(--dc-transition);
}

.doctor-tab svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.doctor-tab:hover {
  color: var(--dc-ink-soft);
  background: rgba(255, 255, 255, 0.65);
}

.doctor-tab.is-active {
  color: var(--dc-primary);
  background: var(--dc-surface);
  box-shadow: var(--dc-shadow-sm);
}

.doctor-tab-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: var(--dc-radius-pill);
  color: var(--dc-primary);
  background: var(--dc-primary-soft);
  font-size: 10px;
  font-weight: 800;
}

.doctor-tab.is-active .doctor-tab-count {
  color: #ffffff;
  background: var(--dc-primary);
}

.doctor-tab-dot,
.doctor-dirty-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #d97706;
  box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.16);
}

.doctor-tab-panels {
  min-width: 0;
}

.doctor-tab-panel {
  min-width: 0;
  animation: doctor-fade-in 180ms ease;
}

.doctor-count-badge {
  flex-shrink: 0;
  padding: 5px 10px;
  border-radius: var(--dc-radius-pill);
  color: var(--dc-primary);
  background: var(--dc-primary-soft);
  font-size: var(--dc-text-xs);
  font-weight: 750;
  white-space: nowrap;
}

.doctor-unsaved-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 4px 9px;
  border-radius: var(--dc-radius-pill);
  color: #9a5b00;
  background: var(--dc-warning-bg);
  font-size: var(--dc-text-xs);
  font-weight: 700;
}

.doctor-inline-loading {
  display: flex;
  align-items: center;
  gap: var(--dc-space-2);
  margin-bottom: var(--dc-space-3);
  padding: 9px 11px;
  border-radius: 9px;
  color: var(--dc-muted);
  background: var(--dc-surface-muted);
  font-size: var(--dc-text-sm);
}

/* --------------------------------------------------------------------------
   Notes form
   -------------------------------------------------------------------------- */

.doctor-consultation-form {
  display: flex;
  flex-direction: column;
  gap: var(--dc-space-5);
}

.doctor-form-section {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.doctor-form-legend {
  display: flex;
  align-items: center;
  gap: var(--dc-space-2);
  width: 100%;
  margin-bottom: var(--dc-space-3);
  padding: 0 0 var(--dc-space-2);
  border-bottom: 1px solid var(--dc-line);
  color: var(--dc-ink);
  font-size: var(--dc-text-md);
  font-weight: 700;
}

.doctor-form-step {
  display: inline-grid;
  place-items: center;
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 50%;
  color: var(--dc-primary);
  background: var(--dc-primary-soft);
  font-size: 11px;
  font-weight: 800;
}

.doctor-form-legend-hint {
  margin-left: auto;
  color: var(--dc-muted);
  font-size: var(--dc-text-xs);
  font-weight: 500;
}

.doctor-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.doctor-form-grid--complaint {
  grid-template-columns: minmax(0, 1.6fr) minmax(0, 0.9fr);
}

.doctor-form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.doctor-form-field--full {
  grid-column: 1 / -1;
}

.doctor-form-field label {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  color: var(--dc-ink-soft);
  font-size: var(--dc-text-base);
  font-weight: 650;
}

.doctor-required {
  color: var(--dc-danger);
  font-weight: 800;
}

.doctor-field-badge {
  padding: 1px 6px;
  border-radius: var(--dc-radius-pill);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.doctor-field-badge--required {
  color: var(--dc-danger);
  background: var(--dc-danger-bg);
}

.doctor-form-field input,
.doctor-form-field textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--dc-line-strong);
  border-radius: 10px;
  color: var(--dc-ink);
  background: var(--dc-surface);
  font: inherit;
  font-size: 13.5px;
  line-height: 1.55;
  transition:
    border-color var(--dc-transition),
    box-shadow var(--dc-transition),
    background-color var(--dc-transition);
}

.doctor-form-field textarea {
  min-height: 82px;
  resize: vertical;
}

.doctor-form-field input::placeholder,
.doctor-form-field textarea::placeholder {
  color: #93a5b1;
}

.doctor-form-field input:hover,
.doctor-form-field textarea:hover {
  border-color: #aebfc9;
}

.doctor-form-field input:focus,
.doctor-form-field textarea:focus {
  outline: none;
  border-color: var(--dc-primary);
  box-shadow: var(--dc-focus-ring);
}

.doctor-field-hint {
  color: var(--dc-muted);
  font-size: 11.5px;
  line-height: 1.4;
}

/* Sticky save feedback bar */
.doctor-save-bar {
  position: sticky;
  bottom: var(--dc-space-3);
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--dc-space-3);
  margin-top: var(--dc-space-1);
  padding: 10px 12px;
  border: 1px solid var(--dc-line);
  border-radius: var(--dc-radius-md);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 -6px 22px rgba(16, 32, 46, 0.08);
  backdrop-filter: blur(8px);
}

.doctor-save-bar.is-dirty {
  border-color: #f0d69b;
}

.doctor-save-state {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-sm);
  font-weight: 650;
}

.doctor-save-state svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

.doctor-save-state.is-saved {
  color: var(--dc-success);
}

.doctor-save-state.is-dirty {
  color: #9a5b00;
}

.doctor-save-state.is-error {
  color: var(--dc-danger);
}

.doctor-save-button {
  min-width: 132px;
  flex-shrink: 0;
}

/* --------------------------------------------------------------------------
   Test results
   -------------------------------------------------------------------------- */

.doctor-result-grid,
.doctor-skeleton-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.doctor-result-card {
  min-width: 0;
  padding: 12px 14px;
  border: 1px solid var(--dc-line);
  border-left: 3px solid var(--dc-line-strong);
  border-radius: 10px;
  background: var(--dc-surface);
  transition: box-shadow var(--dc-transition), border-color var(--dc-transition);
}

.doctor-result-card:hover {
  box-shadow: var(--dc-shadow-sm);
}

.doctor-result-card.is-success {
  border-left-color: var(--dc-primary);
}

.doctor-result-card.is-danger {
  border-left-color: var(--dc-danger-strong);
  background: #fffafa;
}

.doctor-result-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--dc-space-2);
}

.doctor-result-header > div {
  min-width: 0;
}

.doctor-result-header h3 {
  margin: 0;
  color: var(--dc-ink);
  font-size: 13.5px;
  font-weight: 700;
  line-height: 1.3;
}

.doctor-result-code {
  display: block;
  margin-top: 2px;
  color: var(--dc-muted);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.doctor-result-status {
  flex-shrink: 0;
  padding: 3px 7px;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  white-space: nowrap;
}

.doctor-result-status.is-success {
  color: var(--dc-success);
  background: var(--dc-success-bg);
}

.doctor-result-status.is-neutral {
  color: var(--dc-muted);
  background: var(--dc-surface-muted);
}

.doctor-result-value {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;
  margin-top: 9px;
}

.doctor-result-value strong {
  color: var(--dc-ink);
  font-size: 20px;
  font-weight: 750;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

.doctor-result-value > span {
  color: var(--dc-muted);
  font-size: var(--dc-text-sm);
}

.doctor-result-value > .doctor-result-flag {
  color: var(--dc-danger);
  font-size: 10px;
}

.doctor-result-flag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: var(--dc-radius-pill);
  color: var(--dc-danger);
  background: var(--dc-danger-bg);
  font-size: 10px;
  font-weight: 750;
}

.doctor-result-flag svg {
  width: 11px;
  height: 11px;
}

.doctor-result-remarks {
  margin: 9px 0 0;
  padding-top: 8px;
  border-top: 1px dashed var(--dc-line);
  color: var(--dc-muted);
  font-size: 11.5px;
  line-height: 1.5;
}

.doctor-result-remarks strong {
  display: block;
  margin-bottom: 1px;
  color: var(--dc-ink-soft);
  font-size: 10px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

/* --------------------------------------------------------------------------
   Underwriting
   -------------------------------------------------------------------------- */

.doctor-underwriting-summary {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 var(--dc-space-3);
}

.doctor-underwriting-summary > div {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid var(--dc-line);
  border-radius: 10px;
  background: var(--dc-surface-muted);
}

.doctor-underwriting-summary dt {
  margin-bottom: 3px;
  color: var(--dc-muted);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.doctor-underwriting-summary dd {
  margin: 0;
  color: var(--dc-ink-soft);
  font-size: var(--dc-text-base);
  font-weight: 700;
}

.doctor-underwriting-groups {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.doctor-underwriting-group {
  min-width: 0;
  padding: 11px 13px;
  border: 1px solid var(--dc-line);
  border-left: 3px solid var(--dc-primary);
  border-radius: 10px;
  background: var(--dc-surface);
}

.doctor-underwriting-group h4 {
  margin: 0 0 8px;
  color: var(--dc-ink);
  font-size: 13px;
  font-weight: 700;
}

.doctor-underwriting-facts {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 7px 12px;
  margin: 0;
}

.doctor-underwriting-facts > div {
  min-width: 0;
}

.doctor-underwriting-facts dt {
  margin-bottom: 1px;
  color: var(--dc-muted);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

.doctor-underwriting-facts dd {
  margin: 0;
  color: var(--dc-ink-soft);
  font-size: var(--dc-text-sm);
  font-weight: 650;
}

.doctor-underwriting-facts dd.is-flagged,
.doctor-underwriting-summary dd.is-flagged {
  color: var(--dc-danger);
  font-weight: 750;
}

.doctor-underwriting-facts dd.is-normal,
.doctor-underwriting-summary dd.is-normal {
  color: var(--dc-success);
}

/* --------------------------------------------------------------------------
   Empty, skeleton and state cards
   -------------------------------------------------------------------------- */

.doctor-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: var(--dc-space-7) var(--dc-space-5);
  border: 1px dashed var(--dc-line-strong);
  border-radius: var(--dc-radius-md);
  background: var(--dc-surface-muted);
  text-align: center;
}

.doctor-empty-state-icon {
  display: grid;
  place-items: center;
  width: 48px;
  height: 48px;
  margin-bottom: var(--dc-space-2);
  border-radius: 50%;
  color: var(--dc-primary);
  background: var(--dc-primary-soft);
}

.doctor-empty-state-icon svg {
  width: 22px;
  height: 22px;
}

.doctor-empty-state h3 {
  margin: 0;
  color: var(--dc-ink);
  font-size: var(--dc-text-md);
  font-weight: 700;
}

.doctor-empty-state p {
  max-width: 330px;
  margin: 2px 0 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-sm);
  line-height: 1.6;
}

.doctor-skeleton-card {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 14px;
  border: 1px solid var(--dc-line);
  border-radius: 10px;
  background: var(--dc-surface);
}

.doctor-skeleton-line {
  display: block;
  width: 100%;
  height: 10px;
  border-radius: var(--dc-radius-pill);
  background: linear-gradient(90deg, #e8eef2 25%, #f7fafb 37%, #e8eef2 63%);
  background-size: 400% 100%;
  animation: doctor-shimmer 1.4s ease infinite;
}

.doctor-skeleton-line.is-short {
  width: 52%;
}

.doctor-skeleton-line.is-value {
  width: 36%;
  height: 18px;
}

.doctor-page-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--dc-space-3);
  min-height: 62vh;
  color: var(--dc-muted);
  font-size: var(--dc-text-md);
}

.doctor-page-loading p {
  margin: 0;
}

.doctor-state-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--dc-space-2);
  max-width: 560px;
  margin: clamp(24px, 8vh, 90px) auto 0;
  padding: var(--dc-space-7) var(--dc-space-6);
  border: 1px solid var(--dc-line);
  border-radius: var(--dc-radius-xl);
  background: var(--dc-surface);
  box-shadow: var(--dc-shadow-md);
  text-align: center;
}

.doctor-state-icon {
  display: grid;
  place-items: center;
  width: 60px;
  height: 60px;
  margin-bottom: var(--dc-space-2);
  border-radius: 50%;
}

.doctor-state-icon svg {
  width: 26px;
  height: 26px;
}

.doctor-state-icon--success {
  color: var(--dc-success);
  background: var(--dc-success-bg);
}

.doctor-state-icon--danger {
  color: var(--dc-danger);
  background: var(--dc-danger-bg);
}

.doctor-state-card h1 {
  margin: 0;
  font-size: var(--dc-text-2xl);
  font-weight: 700;
  line-height: 1.2;
}

.doctor-state-card > p {
  max-width: 400px;
  margin: 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-md);
  line-height: 1.6;
}

.doctor-state-card > p strong {
  color: var(--dc-ink-soft);
}

.doctor-state-card .doctor-button {
  margin-top: var(--dc-space-3);
}

.doctor-state-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--dc-space-2);
  width: 100%;
  max-width: 360px;
  margin: var(--dc-space-3) 0 var(--dc-space-1);
}

.doctor-state-details > div {
  padding: 10px 14px;
  border: 1px solid var(--dc-line);
  border-radius: 10px;
  background: var(--dc-surface-muted);
}

.doctor-state-details dt {
  margin-bottom: 2px;
  color: var(--dc-muted);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.doctor-state-details dd {
  margin: 0;
  color: var(--dc-ink-soft);
  font-size: var(--dc-text-md);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

/* --------------------------------------------------------------------------
   End-call modal
   -------------------------------------------------------------------------- */

.doctor-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: grid;
  place-items: center;
  padding: var(--dc-space-5);
  background: rgba(7, 20, 28, 0.56);
  backdrop-filter: blur(4px);
  animation: doctor-fade-in 160ms ease;
}

.doctor-modal {
  width: min(440px, 100%);
  padding: var(--dc-space-6);
  border: 1px solid var(--dc-line);
  border-radius: var(--dc-radius-xl);
  background: var(--dc-surface);
  box-shadow: var(--dc-shadow-lg);
  animation: doctor-pop-in 200ms ease;
}

.doctor-modal-icon {
  display: grid;
  place-items: center;
  width: 52px;
  height: 52px;
  margin-bottom: var(--dc-space-3);
  border-radius: 50%;
  color: var(--dc-danger);
  background: var(--dc-danger-bg);
}

.doctor-modal-icon svg {
  width: 23px;
  height: 23px;
}

.doctor-modal h2 {
  margin: 0 0 var(--dc-space-2);
  font-size: var(--dc-text-xl);
  font-weight: 700;
  line-height: 1.3;
}

.doctor-modal > p {
  margin: 0;
  color: var(--dc-muted);
  font-size: var(--dc-text-md);
  line-height: 1.6;
}

.doctor-modal > p strong {
  color: var(--dc-ink-soft);
}

.doctor-modal .doctor-alert {
  margin-top: var(--dc-space-3);
}

.doctor-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--dc-space-2);
  margin-top: var(--dc-space-5);
}

/* --------------------------------------------------------------------------
   Responsive
   -------------------------------------------------------------------------- */

@media (max-width: 1200px) {
  .doctor-live-layout {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .doctor-info-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .doctor-underwriting-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1024px) {
  .doctor-live-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .doctor-live-sidebar,
  .doctor-waiting-card {
    position: static;
  }

  .doctor-video-stage {
    max-height: 62vh;
  }

  .doctor-tabs {
    top: var(--dc-space-2);
  }
}

@media (max-width: 900px) {
  .doctor-waiting-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .doctor-waiting-card {
    padding: var(--dc-space-6);
  }

  .doctor-form-grid,
  .doctor-form-grid--complaint {
    grid-template-columns: minmax(0, 1fr);
  }

  .doctor-underwriting-groups {
    grid-template-columns: minmax(0, 1fr);
  }

  .doctor-underwriting-facts {
    grid-template-columns: minmax(0, 1fr);
  }
}

@media (max-width: 700px) {
  .doctor-call-page {
    padding: var(--dc-space-3) var(--dc-space-3) var(--dc-space-7);
  }

  .doctor-page-header {
    align-items: flex-start;
    flex-direction: column;
    gap: var(--dc-space-2);
  }

  .doctor-page-heading {
    width: 100%;
  }

  .doctor-page-heading h1 {
    font-size: var(--dc-text-xl);
  }

  .doctor-status-badge {
    align-self: flex-start;
  }

  .doctor-patient-bar {
    align-items: flex-start;
    flex-direction: column;
  }

  .doctor-patient-flags {
    width: 100%;
  }

  .doctor-result-grid,
  .doctor-skeleton-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .doctor-video-panel,
  .doctor-notes-panel {
    padding: 10px;
  }

  .doctor-video-stage {
    aspect-ratio: 4 / 3;
  }

  .doctor-call-controls {
    gap: var(--dc-space-5);
  }

  .doctor-control-button {
    width: 58px;
    height: 58px;
    min-height: 58px;
  }

  .doctor-modal-actions {
    flex-direction: column-reverse;
  }

  .doctor-modal-actions .doctor-button {
    width: 100%;
  }
}

@media (max-width: 560px) {
  .doctor-tabs {
    display: flex;
    gap: 3px;
    overflow-x: auto;
    padding: 3px;
    scrollbar-width: none;
  }

  .doctor-tabs::-webkit-scrollbar {
    display: none;
  }

  .doctor-tab {
    flex: 1 0 auto;
    min-height: 44px;
    padding: 0 10px;
    font-size: var(--dc-text-xs);
  }

  .doctor-tab svg {
    display: none;
  }

  .doctor-info-card {
    padding: var(--dc-space-4);
  }

  .doctor-info-grid,
  .doctor-state-details {
    grid-template-columns: minmax(0, 1fr);
  }

  .doctor-form-legend-hint {
    display: none;
  }

  .doctor-save-bar {
    align-items: stretch;
    flex-direction: column;
  }

  .doctor-save-button {
    width: 100%;
  }

  .doctor-video-overlay-top {
    top: 9px;
    left: 9px;
    right: 9px;
  }

  .doctor-room-chip {
    max-width: 48%;
  }

  .doctor-local-video-wrap {
    right: 9px;
    bottom: 9px;
    width: 32%;
  }

  .doctor-underwriting-summary {
    grid-template-columns: minmax(0, 1fr);
  }

  .doctor-state-card {
    padding: var(--dc-space-6) var(--dc-space-4);
  }
}

@media (prefers-reduced-motion: reduce) {
  .doctor-call-page *,
  .doctor-call-page *::before,
  .doctor-call-page *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}

/* ==========================================================================
   DOCTOR TELECONSULTATIONS LIST PAGE (shared stylesheet)
   ========================================================================== */

.doctor-tele-page {
  min-height: 100vh;
  padding: 32px;
  background: #f5f8fa;
  box-sizing: border-box;
  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Arial,
    sans-serif;
  color: #1f2937;
}

.doctor-tele-header {
  max-width: 1200px;
  margin: 0 auto 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.doctor-tele-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
}

.doctor-page-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e7f7f6;
  color: #0f9f9a;
  font-size: 25px;
  flex-shrink: 0;
}

.doctor-tele-header h1 {
  margin: 0;
  font-size: 28px;
  line-height: 1.25;
  font-weight: 700;
  color: #17212b;
}

.doctor-tele-header p {
  margin: 6px 0 0;
  font-size: 14px;
  color: #718096;
}

.doctor-refresh-button {
  height: 42px;
  padding: 0 18px;
  border: 1px solid #d6e2e8;
  border-radius: 9px;
  background: #ffffff;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.doctor-refresh-button:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #b8cbd4;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.06);
}

.doctor-refresh-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.refresh-icon {
  font-size: 20px;
  line-height: 1;
}

.refresh-icon.spinning {
  animation: refresh-spin 0.9s linear infinite;
}

@keyframes refresh-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.doctor-loading-container {
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #64748b;
}

.doctor-loading-container p {
  margin: 14px 0 0;
  font-size: 14px;
}

.doctor-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #dceceb;
  border-top-color: #11a8a4;
  border-radius: 50%;
  animation: doctor-spinner-animation 0.8s linear infinite;
}

@keyframes doctor-spinner-animation {
  to {
    transform: rotate(360deg);
  }
}

.doctor-error {
  max-width: 1200px;
  margin: 0 auto 20px;
  padding: 13px 16px;
  border: 1px solid #fecaca;
  border-radius: 9px;
  background: #fff5f5;
  color: #b42318;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.error-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fee2e2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  flex-shrink: 0;
}

.doctor-consultation-list {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
}

.doctor-consultation-card {
  background: #ffffff;
  border: 1px solid #e3eaee;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}

.doctor-consultation-card:hover {
  transform: translateY(-2px);
  border-color: #c9dddd;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.consultation-card-top {
  padding: 20px 20px 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf2f4;
}

.patient-heading {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 13px;
}

.patient-avatar {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #e7f7f6;
  color: #0f9f9a;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  flex-shrink: 0;
}

.patient-heading h2 {
  margin: 0;
  font-size: 17px;
  line-height: 1.35;
  font-weight: 700;
  color: #17212b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patient-heading p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #7b8794;
}

.status-badge {
  min-height: 28px;
  padding: 5px 10px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  white-space: nowrap;
}

.status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}

.status-waiting {
  background: #fff7df;
  color: #996c00;
}

.status-waiting .status-dot {
  background: #d99a00;
}

.status-ongoing {
  background: #e5f8ef;
  color: #137a4a;
}

.status-ongoing .status-dot {
  background: #16a05d;
}

.status-completed {
  background: #eef2f6;
  color: #64748b;
}

.status-completed .status-dot {
  background: #64748b;
}

.status-cancelled {
  background: #fff0f0;
  color: #b42318;
}

.status-cancelled .status-dot {
  background: #d92d20;
}

.status-unknown {
  background: #f1f5f9;
  color: #64748b;
}

.status-unknown .status-dot {
  background: #94a3b8;
}

.consultation-info-grid {
  padding: 18px 20px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 22px;
  row-gap: 17px;
}

.consultation-info-item {
  min-width: 0;
}

.consultation-info-item span {
  display: block;
  margin-bottom: 5px;
  font-size: 11px;
  font-weight: 600;
  color: #8a98a6;
  text-transform: uppercase;
  letter-spacing: 0.45px;
}

.consultation-info-item strong {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.consultation-card-actions {
  padding: 0 20px 20px;
}

.consultation-open-button {
  width: 100%;
  height: 43px;
  border: none;
  border-radius: 9px;
  background: #11a8a4;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  transition:
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.consultation-open-button:hover {
  background: #0d918e;
  box-shadow: 0 4px 12px rgba(17, 168, 164, 0.2);
}

.consultation-open-button:active {
  transform: translateY(1px);
}

.consultation-open-button.button-ongoing {
  background: #168653;
}

.consultation-open-button.button-ongoing:hover {
  background: #117344;
}

.button-arrow {
  font-size: 19px;
  line-height: 1;
  transition: transform 0.2s ease;
}

.consultation-open-button:hover .button-arrow {
  transform: translateX(3px);
}

.doctor-empty {
  max-width: 600px;
  margin: 70px auto;
  padding: 45px 30px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e3eaee;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
}

.doctor-empty-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 18px;
  border-radius: 50%;
  background: #e7f7f6;
  color: #11a8a4;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 27px;
}

.doctor-empty h3 {
  margin: 0;
  font-size: 19px;
  font-weight: 700;
  color: #273444;
}

.doctor-empty p {
  max-width: 420px;
  margin: 8px auto 22px;
  font-size: 14px;
  line-height: 1.6;
  color: #7b8794;
}

.doctor-empty-refresh {
  height: 40px;
  padding: 0 18px;
  border: 1px solid #cfe4e3;
  border-radius: 8px;
  background: #ffffff;
  color: #0f918e;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.doctor-empty-refresh:hover:not(:disabled) {
  background: #f0fbfa;
}

.doctor-empty-refresh:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.doctor-header-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 9px;
  min-width: 145px;
}

.doctor-logout-button {
  width: 100%;
  height: 42px;
  padding: 0 18px;
  border: 1px solid #f1caca;
  border-radius: 9px;
  background: #ffffff;
  color: #c0392b;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    color 0.2s ease;
}

.doctor-logout-button:hover {
  background: #fff5f5;
  border-color: #e7a9a9;
  color: #b42318;
  box-shadow: 0 2px 7px rgba(180, 35, 24, 0.08);
}

.doctor-logout-button:active {
  transform: translateY(1px);
}

.logout-icon {
  font-size: 18px;
  line-height: 1;
}

@media (max-width: 900px) {
  .doctor-tele-page {
    padding: 24px;
  }

  .doctor-consultation-list {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .doctor-tele-page {
    padding: 16px;
  }

  .doctor-tele-header {
    align-items: flex-start;
    flex-direction: column;
    margin-bottom: 20px;
  }

  .doctor-tele-title-section {
    width: 100%;
  }

  .doctor-page-icon {
    width: 46px;
    height: 46px;
    font-size: 21px;
  }

  .doctor-tele-header h1 {
    font-size: 23px;
  }

  .doctor-tele-header p {
    font-size: 13px;
    line-height: 1.5;
  }

  .doctor-refresh-button {
    width: 100%;
  }

  .consultation-card-top {
    padding: 16px;
    flex-direction: column;
  }

  .patient-heading {
    width: 100%;
  }

  .patient-heading h2 {
    font-size: 16px;
  }

  .status-badge {
    align-self: flex-start;
  }

  .consultation-info-grid {
    padding: 16px;
    grid-template-columns: 1fr;
    row-gap: 14px;
  }

  .consultation-card-actions {
    padding: 0 16px 16px;
  }

  .doctor-empty {
    margin: 40px auto;
    padding: 35px 20px;
  }

  .doctor-header-actions {
    width: 100%;
    min-width: 0;
  }

  .doctor-refresh-button,
  .doctor-logout-button {
    width: 100%;
  }
}

@media (max-width: 380px) {
  .doctor-tele-page {
    padding: 12px;
  }

  .doctor-tele-title-section {
    gap: 10px;
  }

  .doctor-tele-header h1 {
    font-size: 21px;
  }

  .doctor-page-icon {
    width: 42px;
    height: 42px;
    border-radius: 11px;
  }

  .patient-avatar {
    width: 42px;
    height: 42px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/doctor-teleconsultation/DoctorTeleConsultationPage.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,0BAA0B;EAC1B,0BAA0B;;EAE1B,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;;EAEnB,kBAAkB;EAClB,yBAAyB;;EAEzB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;;EAEhB,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;;EAErB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;;EAElB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;;EAEvB,gDAAgD;EAChD,iDAAiD;EACjD,iDAAiD;;EAEjD,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,2BAA2B;EAC3B,mDAAmD;;EAEnD,iBAAiB;EACjB,qEAAqE;EACrE,oBAAoB;EACpB,8BAA8B;EAC9B;;oFAEkF;EAClF,qFAAqF;EACrF,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;+EAE+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB;;;;kCAIgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,wCAAwC;EACxC,mCAAmC;EACnC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mCAAmC;EACnC,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,4CAA4C;EAC9C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;;;EAIE,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;EAChC,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;;;EAGE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;EAClB;;qBAEmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,uDAAuD;EACvD,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;AACd;;AAEA;;+EAE+E;;AAE/E;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd;;yBAEuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,oCAAoC;EACpC,cAAc;EACd,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,kCAAkC;EAClC,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,wCAAwC;EACxC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC;;;;;mCAKiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,+BAA+B;EAC/B,oBAAoB;EACpB,wEAAwE;AAC1E;;AAEA;;EAEE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;EACV,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,YAAY;EACZ,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB;;;mCAGiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,wBAAwB;EACxB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,wBAAwB;EACxB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;EACd,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gCAAgC;EAChC,8BAA8B;EAC9B,uCAAuC;EACvC,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB;;;yCAGuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,qCAAqC;EACrC,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,4CAA4C;EAC5C,mBAAmB;EACnB,6BAA6B;EAC7B,8EAA8E;AAChF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,wCAAwC;EACxC,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,yEAAyE;EACzE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,qCAAqC;EACrC,4CAA4C;EAC5C,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,iCAAiC;EACjC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,gCAAgC;EAChC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,8DAA8D;EAChE;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,qCAAqC;EACvC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;;;IAGE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;IACvC,gCAAgC;EAClC;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB;;;;;;;cAOY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR;;;wBAGsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wDAAwD;AAC1D;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C;;;0BAGwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf;;;wBAGsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR;;;;mBAIiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,0BAA0B;IAC1B,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* ==========================================================================\r\n   DOCTOR TELECONSULTATION\r\n   Design tokens, layout, video, notes workspace, feedback states.\r\n   ========================================================================== */\r\n\r\n.doctor-call-page {\r\n  --dc-primary: #0f766e;\r\n  --dc-primary-strong: #0b5f59;\r\n  --dc-primary-soft: #e4f4f1;\r\n  --dc-primary-tint: #f2faf8;\r\n\r\n  --dc-ink: #10202e;\r\n  --dc-ink-soft: #33475b;\r\n  --dc-muted: #5a6b7c;\r\n\r\n  --dc-line: #dfe8ec;\r\n  --dc-line-strong: #c6d5dd;\r\n\r\n  --dc-surface: #ffffff;\r\n  --dc-surface-muted: #f6f9fa;\r\n  --dc-bg: #eef4f4;\r\n\r\n  --dc-success: #147a4b;\r\n  --dc-success-bg: #e6f6ee;\r\n  --dc-warning: #8a5a00;\r\n  --dc-warning-bg: #fff5dc;\r\n  --dc-danger: #b42318;\r\n  --dc-danger-strong: #d92d20;\r\n  --dc-danger-bg: #fdecec;\r\n  --dc-info: #175cd3;\r\n  --dc-info-bg: #eef4ff;\r\n\r\n  --dc-space-1: 4px;\r\n  --dc-space-2: 8px;\r\n  --dc-space-3: 12px;\r\n  --dc-space-4: 16px;\r\n  --dc-space-5: 20px;\r\n  --dc-space-6: 24px;\r\n  --dc-space-7: 32px;\r\n  --dc-space-8: 40px;\r\n\r\n  --dc-radius-sm: 8px;\r\n  --dc-radius-md: 12px;\r\n  --dc-radius-lg: 16px;\r\n  --dc-radius-xl: 22px;\r\n  --dc-radius-pill: 999px;\r\n\r\n  --dc-shadow-sm: 0 1px 2px rgba(16, 32, 46, 0.06);\r\n  --dc-shadow-md: 0 8px 24px rgba(16, 32, 46, 0.08);\r\n  --dc-shadow-lg: 0 24px 60px rgba(16, 32, 46, 0.2);\r\n\r\n  --dc-text-xs: 11px;\r\n  --dc-text-sm: 12px;\r\n  --dc-text-base: 13px;\r\n  --dc-text-md: 14px;\r\n  --dc-text-lg: 16px;\r\n  --dc-text-xl: 18px;\r\n  --dc-text-2xl: 22px;\r\n  --dc-text-3xl: 28px;\r\n\r\n  --dc-transition: 160ms ease;\r\n  --dc-focus-ring: 0 0 0 3px rgba(15, 118, 110, 0.24);\r\n\r\n  min-height: 100vh;\r\n  padding: var(--dc-space-5) clamp(14px, 3.2vw, 44px) var(--dc-space-8);\r\n  color: var(--dc-ink);\r\n  background-color: var(--dc-bg);\r\n  background-image:\r\n    radial-gradient(1100px 480px at 8% -12%, rgba(15, 118, 110, 0.1), transparent 62%),\r\n    radial-gradient(900px 420px at 100% 0, rgba(23, 92, 211, 0.05), transparent 60%);\r\n  font-family: \"Segoe UI\", -apple-system, BlinkMacSystemFont, Roboto, Arial, sans-serif;\r\n  font-size: var(--dc-text-md);\r\n  line-height: 1.5;\r\n}\r\n\r\n.doctor-call-page *,\r\n.doctor-call-page *::before,\r\n.doctor-call-page *::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.doctor-call-page button {\r\n  font: inherit;\r\n  cursor: pointer;\r\n}\r\n\r\n.doctor-call-page :is(button, input, textarea, [tabindex]):focus-visible {\r\n  outline: 3px solid rgba(15, 118, 110, 0.42);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.doctor-call-page h1,\r\n.doctor-call-page h2,\r\n.doctor-call-page h3,\r\n.doctor-call-page h4,\r\n.doctor-call-page p,\r\n.doctor-call-page dl,\r\n.doctor-call-page dd {\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.doctor-visually-hidden {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  margin: -1px;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  clip: rect(0 0 0 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}\r\n\r\n.doctor-eyebrow {\r\n  margin: 0 0 2px;\r\n  color: var(--dc-primary);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 700;\r\n  letter-spacing: 0.08em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Shared controls\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--dc-space-2);\r\n  min-height: 44px;\r\n  padding: 0 var(--dc-space-4);\r\n  border: 1px solid transparent;\r\n  border-radius: 10px;\r\n  color: #ffffff;\r\n  background: var(--dc-primary);\r\n  font-size: var(--dc-text-base);\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n  transition:\r\n    background-color var(--dc-transition),\r\n    border-color var(--dc-transition),\r\n    box-shadow var(--dc-transition),\r\n    transform var(--dc-transition);\r\n}\r\n\r\n.doctor-button svg {\r\n  width: 17px;\r\n  height: 17px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.doctor-button:hover:not(:disabled) {\r\n  background: var(--dc-primary-strong);\r\n  box-shadow: 0 6px 16px rgba(15, 118, 110, 0.22);\r\n}\r\n\r\n.doctor-button:active:not(:disabled) {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.doctor-button:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.doctor-button--secondary {\r\n  color: var(--dc-ink-soft);\r\n  background: var(--dc-surface);\r\n  border-color: var(--dc-line-strong);\r\n}\r\n\r\n.doctor-button--secondary:hover:not(:disabled) {\r\n  background: var(--dc-surface-muted);\r\n  box-shadow: var(--dc-shadow-sm);\r\n}\r\n\r\n.doctor-button--danger {\r\n  color: #ffffff;\r\n  background: var(--dc-danger-strong);\r\n}\r\n\r\n.doctor-button--danger:hover:not(:disabled) {\r\n  background: #b42318;\r\n  box-shadow: 0 6px 16px rgba(217, 45, 32, 0.24);\r\n}\r\n\r\n.doctor-button--lg {\r\n  min-height: 50px;\r\n  padding: 0 var(--dc-space-6);\r\n  font-size: var(--dc-text-md);\r\n}\r\n\r\n.doctor-button-spinner {\r\n  width: 14px;\r\n  height: 14px;\r\n  border: 2px solid rgba(255, 255, 255, 0.4);\r\n  border-top-color: #ffffff;\r\n  border-radius: 50%;\r\n  animation: doctor-spin 0.7s linear infinite;\r\n}\r\n\r\n.doctor-button--secondary .doctor-button-spinner {\r\n  border-color: rgba(15, 118, 110, 0.24);\r\n  border-top-color: var(--dc-primary);\r\n}\r\n\r\n.doctor-spinner-sm {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n  border: 2px solid var(--dc-primary-soft);\r\n  border-top-color: var(--dc-primary);\r\n  border-radius: 50%;\r\n  animation: doctor-spin 0.7s linear infinite;\r\n}\r\n\r\n.doctor-page-spinner {\r\n  width: 38px;\r\n  height: 38px;\r\n  border: 3px solid var(--dc-line);\r\n  border-top-color: var(--dc-primary);\r\n  border-radius: 50%;\r\n  animation: doctor-spin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes doctor-spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes doctor-pulse {\r\n  0%,\r\n  100% {\r\n    box-shadow: 0 0 0 0 rgba(226, 168, 47, 0.35);\r\n  }\r\n  50% {\r\n    box-shadow: 0 0 0 6px rgba(226, 168, 47, 0);\r\n  }\r\n}\r\n\r\n@keyframes doctor-fade-in {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes doctor-pop-in {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(8px) scale(0.98);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n@keyframes doctor-shimmer {\r\n  0% {\r\n    background-position: 100% 50%;\r\n  }\r\n  100% {\r\n    background-position: 0 50%;\r\n  }\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Header\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-page-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--dc-space-4);\r\n  max-width: 1600px;\r\n  margin: 0 auto var(--dc-space-4);\r\n}\r\n\r\n.doctor-page-heading {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: var(--dc-space-3);\r\n  min-width: 0;\r\n}\r\n\r\n.doctor-page-heading h1 {\r\n  margin: 0;\r\n  font-size: var(--dc-text-2xl);\r\n  font-weight: 700;\r\n  line-height: 1.2;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n.doctor-page-subtitle {\r\n  margin: var(--dc-space-1) 0 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-base);\r\n}\r\n\r\n.doctor-page-subtitle strong {\r\n  color: var(--dc-ink-soft);\r\n}\r\n\r\n.doctor-back-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  min-height: 36px;\r\n  margin-top: 2px;\r\n  padding: 0 10px;\r\n  border: 1px solid transparent;\r\n  border-radius: 9px;\r\n  color: var(--dc-muted);\r\n  background: transparent;\r\n  font-size: var(--dc-text-sm);\r\n  font-weight: 650;\r\n}\r\n\r\n.doctor-back-button svg {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n.doctor-back-button:hover {\r\n  color: var(--dc-ink);\r\n  background: var(--dc-surface);\r\n  border-color: var(--dc-line);\r\n}\r\n\r\n.doctor-status-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  flex-shrink: 0;\r\n  padding: 7px 12px;\r\n  border-radius: var(--dc-radius-pill);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 800;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.doctor-status-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: currentColor;\r\n}\r\n\r\n.doctor-status-badge.is-ongoing {\r\n  color: var(--dc-success);\r\n  background: var(--dc-success-bg);\r\n}\r\n\r\n.doctor-status-badge.is-waiting {\r\n  color: var(--dc-warning);\r\n  background: var(--dc-warning-bg);\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Alerts\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-alert {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: var(--dc-space-2);\r\n  padding: 10px 12px;\r\n  border: 1px solid transparent;\r\n  border-radius: 10px;\r\n  font-size: var(--dc-text-base);\r\n  line-height: 1.5;\r\n}\r\n\r\n.doctor-alert svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  margin-top: 2px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.doctor-alert--danger {\r\n  color: var(--dc-danger);\r\n  background: var(--dc-danger-bg);\r\n  border-color: #f7cdc9;\r\n}\r\n\r\n.doctor-alert--warning {\r\n  color: var(--dc-warning);\r\n  background: var(--dc-warning-bg);\r\n  border-color: #f2dfae;\r\n}\r\n\r\n.doctor-alert--info {\r\n  color: var(--dc-info);\r\n  background: var(--dc-info-bg);\r\n  border-color: #cddcf8;\r\n}\r\n\r\n.doctor-alert--success {\r\n  color: var(--dc-success);\r\n  background: var(--dc-success-bg);\r\n  border-color: #c3e8d5;\r\n}\r\n\r\n.doctor-call-page > .doctor-alert {\r\n  max-width: 1600px;\r\n  margin: 0 auto var(--dc-space-3);\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Patient summary bar\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-patient-bar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--dc-space-3);\r\n  padding: 12px 14px;\r\n  background: var(--dc-surface);\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: var(--dc-radius-lg);\r\n  box-shadow: var(--dc-shadow-sm);\r\n}\r\n\r\n.doctor-patient-identity {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--dc-space-3);\r\n  min-width: 0;\r\n}\r\n\r\n.doctor-patient-avatar {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 44px;\r\n  height: 44px;\r\n  flex-shrink: 0;\r\n  border-radius: 14px;\r\n  color: var(--dc-primary);\r\n  background: var(--dc-primary-soft);\r\n  font-size: var(--dc-text-lg);\r\n  font-weight: 800;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.doctor-patient-identity-text {\r\n  min-width: 0;\r\n}\r\n\r\n.doctor-patient-identity-text h2 {\r\n  margin: 0;\r\n  font-size: var(--dc-text-lg);\r\n  font-weight: 700;\r\n  line-height: 1.25;\r\n}\r\n\r\n.doctor-patient-identity-text p {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 2px 7px;\r\n  margin: 3px 0 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-sm);\r\n}\r\n\r\n.doctor-patient-flags {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.doctor-flag {\r\n  display: inline-flex;\r\n  align-items: flex-start;\r\n  gap: 5px;\r\n  max-width: 100%;\r\n  padding: 5px 10px;\r\n  border: 1px solid transparent;\r\n  border-radius: var(--dc-radius-pill);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 700;\r\n  line-height: 1.4;\r\n}\r\n\r\n.doctor-flag svg {\r\n  width: 13px;\r\n  height: 13px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.doctor-flag--danger {\r\n  color: var(--dc-danger);\r\n  background: var(--dc-danger-bg);\r\n  border-color: #f7cdc9;\r\n}\r\n\r\n.doctor-flag--neutral {\r\n  color: var(--dc-muted);\r\n  background: var(--dc-surface-muted);\r\n  border-color: var(--dc-line);\r\n}\r\n\r\n.doctor-flags-list {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: var(--dc-space-2);\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Waiting state\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-waiting-layout {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) 360px;\r\n  gap: var(--dc-space-4);\r\n  align-items: start;\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.doctor-waiting-main {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--dc-space-4);\r\n  min-width: 0;\r\n}\r\n\r\n.doctor-info-card,\r\n.doctor-waiting-card,\r\n.doctor-video-panel,\r\n.doctor-notes-panel {\r\n  min-width: 0;\r\n  background: var(--dc-surface);\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: var(--dc-radius-lg);\r\n  box-shadow: var(--dc-shadow-md);\r\n}\r\n\r\n.doctor-info-card {\r\n  padding: var(--dc-space-5);\r\n}\r\n\r\n.doctor-card-heading,\r\n.doctor-tab-heading {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--dc-space-3);\r\n  margin-bottom: var(--dc-space-4);\r\n}\r\n\r\n.doctor-card-heading h2,\r\n.doctor-card-heading h3,\r\n.doctor-tab-heading h2 {\r\n  margin: 0;\r\n  font-size: var(--dc-text-xl);\r\n  font-weight: 700;\r\n  line-height: 1.25;\r\n}\r\n\r\n.doctor-tab-heading p,\r\n.doctor-card-heading p {\r\n  margin: 3px 0 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-base);\r\n}\r\n\r\n.doctor-info-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n  gap: 14px 20px;\r\n  margin: 0;\r\n}\r\n\r\n.doctor-info-grid dt {\r\n  margin-bottom: 3px;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 650;\r\n  letter-spacing: 0.03em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.doctor-info-grid dd {\r\n  margin: 0;\r\n  color: var(--dc-ink-soft);\r\n  font-size: var(--dc-text-base);\r\n  font-weight: 650;\r\n}\r\n\r\n.doctor-waiting-card {\r\n  position: sticky;\r\n  top: var(--dc-space-4);\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: var(--dc-space-2);\r\n  padding: var(--dc-space-7) var(--dc-space-5);\r\n  text-align: center;\r\n  background:\r\n    radial-gradient(420px 220px at 50% 0, rgba(15, 118, 110, 0.1), transparent 70%),\r\n    var(--dc-surface);\r\n}\r\n\r\n.doctor-waiting-icon {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 58px;\r\n  height: 58px;\r\n  margin-bottom: var(--dc-space-2);\r\n  border-radius: 18px;\r\n  color: var(--dc-primary);\r\n  background: var(--dc-primary-soft);\r\n}\r\n\r\n.doctor-waiting-icon svg {\r\n  width: 26px;\r\n  height: 26px;\r\n}\r\n\r\n.doctor-waiting-card h2 {\r\n  margin: 0;\r\n  font-size: var(--dc-text-xl);\r\n}\r\n\r\n.doctor-waiting-card > p:not(.doctor-eyebrow) {\r\n  margin: 0 0 var(--dc-space-3);\r\n  max-width: 300px;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-base);\r\n  line-height: 1.6;\r\n}\r\n\r\n.doctor-waiting-card .doctor-button {\r\n  width: 100%;\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Live layout\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-live-layout {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.12fr) minmax(0, 1fr);\r\n  gap: var(--dc-space-4);\r\n  align-items: start;\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.doctor-live-sidebar {\r\n  position: sticky;\r\n  top: var(--dc-space-4);\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--dc-space-3);\r\n  min-width: 0;\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Video\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-video-panel {\r\n  padding: var(--dc-space-3);\r\n}\r\n\r\n.doctor-video-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--dc-space-3);\r\n  padding: 2px 2px var(--dc-space-3);\r\n}\r\n\r\n.doctor-video-header h2 {\r\n  margin: 0;\r\n  font-size: var(--dc-text-lg);\r\n  font-weight: 700;\r\n  line-height: 1.25;\r\n}\r\n\r\n.doctor-video-header p {\r\n  margin: 2px 0 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-sm);\r\n}\r\n\r\n.doctor-connection-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n  padding: 6px 10px;\r\n  border-radius: var(--dc-radius-pill);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 800;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.doctor-connection-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: currentColor;\r\n}\r\n\r\n.doctor-connection-badge.is-success {\r\n  color: var(--dc-success);\r\n  background: var(--dc-success-bg);\r\n}\r\n\r\n.doctor-connection-badge.is-pending {\r\n  color: var(--dc-warning);\r\n  background: var(--dc-warning-bg);\r\n}\r\n\r\n.doctor-connection-badge.is-pending .doctor-connection-dot {\r\n  animation: doctor-pulse 1.8s ease-in-out infinite;\r\n}\r\n\r\n.doctor-connection-badge.is-warning {\r\n  color: #9a3412;\r\n  background: #ffedd5;\r\n}\r\n\r\n.doctor-connection-badge.is-warning .doctor-connection-dot {\r\n  animation: doctor-pulse 1.2s ease-in-out infinite;\r\n}\r\n\r\n.doctor-video-stage {\r\n  position: relative;\r\n  width: 100%;\r\n  aspect-ratio: 16 / 10;\r\n  overflow: hidden;\r\n  border-radius: var(--dc-radius-md);\r\n  background: #0b1f2a;\r\n  isolation: isolate;\r\n}\r\n\r\n.doctor-remote-video {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: contain;\r\n  background: #0b1f2a;\r\n}\r\n\r\n.doctor-video-placeholder {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  padding: var(--dc-space-5);\r\n  text-align: center;\r\n  color: #e8f1f3;\r\n  background:\r\n    radial-gradient(420px 260px at 50% 12%, rgba(15, 118, 110, 0.35), transparent 70%),\r\n    rgba(7, 20, 28, 0.86);\r\n}\r\n\r\n.doctor-video-placeholder strong {\r\n  font-size: var(--dc-text-lg);\r\n  font-weight: 650;\r\n}\r\n\r\n.doctor-video-placeholder > span:last-child {\r\n  max-width: 320px;\r\n  color: #a9bcc6;\r\n  font-size: var(--dc-text-sm);\r\n}\r\n\r\n.doctor-video-pulse {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 58px;\r\n  height: 58px;\r\n  margin-bottom: var(--dc-space-2);\r\n  border: 1px solid rgba(255, 255, 255, 0.18);\r\n  border-radius: 50%;\r\n  color: #d9eef0;\r\n  background: rgba(15, 118, 110, 0.32);\r\n  animation: doctor-pulse 2.4s ease-out infinite;\r\n}\r\n\r\n.doctor-video-pulse svg {\r\n  width: 25px;\r\n  height: 25px;\r\n}\r\n\r\n.doctor-video-overlay-top {\r\n  position: absolute;\r\n  top: 12px;\r\n  left: 12px;\r\n  right: 12px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--dc-space-2);\r\n  pointer-events: none;\r\n}\r\n\r\n.doctor-call-timer,\r\n.doctor-room-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 10px;\r\n  border: 1px solid rgba(255, 255, 255, 0.16);\r\n  border-radius: var(--dc-radius-pill);\r\n  color: #ffffff;\r\n  background: rgba(7, 20, 28, 0.62);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 650;\r\n  font-variant-numeric: tabular-nums;\r\n  backdrop-filter: blur(6px);\r\n}\r\n\r\n.doctor-call-timer svg {\r\n  width: 13px;\r\n  height: 13px;\r\n}\r\n\r\n.doctor-room-chip {\r\n  max-width: 55%;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.doctor-local-video-wrap {\r\n  position: absolute;\r\n  right: 12px;\r\n  bottom: 12px;\r\n  width: clamp(104px, 26%, 178px);\r\n  aspect-ratio: 4 / 3;\r\n  overflow: hidden;\r\n  border: 2px solid rgba(255, 255, 255, 0.82);\r\n  border-radius: var(--dc-radius-md);\r\n  background: #1b2f3b;\r\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);\r\n}\r\n\r\n.doctor-local-video {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  transform: scaleX(-1);\r\n}\r\n\r\n.doctor-local-video-label {\r\n  position: absolute;\r\n  left: 6px;\r\n  bottom: 6px;\r\n  padding: 2px 7px;\r\n  border-radius: var(--dc-radius-pill);\r\n  color: #ffffff;\r\n  background: rgba(7, 20, 28, 0.65);\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.03em;\r\n}\r\n\r\n.doctor-camera-off {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  color: #dbe7ea;\r\n  background: #1b2f3b;\r\n  font-size: var(--dc-text-xs);\r\n}\r\n\r\n.doctor-camera-off svg {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.doctor-video-panel > .doctor-alert {\r\n  margin-top: var(--dc-space-3);\r\n}\r\n\r\n.doctor-media-retry {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--dc-space-3);\r\n  margin-top: var(--dc-space-3);\r\n  padding: var(--dc-space-3);\r\n  border: 1px dashed var(--dc-line-strong);\r\n  border-radius: 10px;\r\n  background: var(--dc-surface-muted);\r\n}\r\n\r\n.doctor-media-retry p {\r\n  flex: 1 1 240px;\r\n  margin: 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-sm);\r\n  line-height: 1.5;\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Call controls\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-call-controls {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: center;\r\n  gap: var(--dc-space-6);\r\n  padding: var(--dc-space-4) 0 var(--dc-space-1);\r\n}\r\n\r\n.doctor-control {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.doctor-control-button {\r\n  position: relative;\r\n  display: grid;\r\n  place-items: center;\r\n  width: 56px;\r\n  height: 56px;\r\n  min-height: 56px;\r\n  padding: 0;\r\n  border: 1px solid var(--dc-line-strong);\r\n  border-radius: 50%;\r\n  color: var(--dc-ink-soft);\r\n  background: var(--dc-surface-muted);\r\n  transition:\r\n    background-color var(--dc-transition),\r\n    border-color var(--dc-transition),\r\n    color var(--dc-transition),\r\n    transform var(--dc-transition),\r\n    box-shadow var(--dc-transition);\r\n}\r\n\r\n.doctor-control-button svg {\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n.doctor-control-button:hover:not(:disabled) {\r\n  border-color: var(--dc-primary);\r\n  color: var(--dc-primary);\r\n  background: var(--dc-primary-soft);\r\n  transform: translateY(-1px);\r\n  box-shadow: var(--dc-shadow-sm);\r\n}\r\n\r\n.doctor-control-button:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.doctor-control-button.is-off {\r\n  border-color: #f2c9c6;\r\n  color: var(--dc-danger);\r\n  background: var(--dc-danger-bg);\r\n}\r\n\r\n.doctor-control-button--danger {\r\n  border-color: var(--dc-danger-strong);\r\n  color: #ffffff;\r\n  background: var(--dc-danger-strong);\r\n  box-shadow: 0 6px 16px rgba(217, 45, 32, 0.26);\r\n}\r\n\r\n.doctor-control-button--danger:hover:not(:disabled) {\r\n  border-color: #b42318;\r\n  color: #ffffff;\r\n  background: #b42318;\r\n  box-shadow: 0 8px 20px rgba(217, 45, 32, 0.32);\r\n}\r\n\r\n.doctor-control-button::after {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  bottom: calc(100% + 9px);\r\n  left: 50%;\r\n  padding: 5px 9px;\r\n  border-radius: 6px;\r\n  color: #ffffff;\r\n  background: var(--dc-ink);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  transform: translate(-50%, 3px);\r\n  pointer-events: none;\r\n  transition: opacity var(--dc-transition), transform var(--dc-transition);\r\n}\r\n\r\n.doctor-control-button:hover::after,\r\n.doctor-control-button:focus-visible::after {\r\n  opacity: 1;\r\n  transform: translate(-50%, 0);\r\n}\r\n\r\n.doctor-control-caption {\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 600;\r\n}\r\n\r\n.doctor-joining-message {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--dc-space-2);\r\n  margin: var(--dc-space-2) 0 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-sm);\r\n}\r\n\r\n.doctor-call-page > .doctor-alert,\r\n.doctor-page-header,\r\n.doctor-live-layout,\r\n.doctor-waiting-layout {\r\n  width: 100%;\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Notes workspace: tabs\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-notes-panel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--dc-space-3);\r\n  padding: var(--dc-space-3);\r\n}\r\n\r\n.doctor-tabs {\r\n  position: sticky;\r\n  top: var(--dc-space-4);\r\n  z-index: 5;\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 4px;\r\n  padding: 4px;\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: var(--dc-radius-md);\r\n  background: var(--dc-surface-muted);\r\n}\r\n\r\n.doctor-tab {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  min-height: 42px;\r\n  padding: 0 8px;\r\n  border: 0;\r\n  border-radius: 9px;\r\n  color: var(--dc-muted);\r\n  background: transparent;\r\n  font-size: var(--dc-text-sm);\r\n  font-weight: 650;\r\n  white-space: nowrap;\r\n  transition:\r\n    background-color var(--dc-transition),\r\n    color var(--dc-transition),\r\n    box-shadow var(--dc-transition);\r\n}\r\n\r\n.doctor-tab svg {\r\n  width: 16px;\r\n  height: 16px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.doctor-tab:hover {\r\n  color: var(--dc-ink-soft);\r\n  background: rgba(255, 255, 255, 0.65);\r\n}\r\n\r\n.doctor-tab.is-active {\r\n  color: var(--dc-primary);\r\n  background: var(--dc-surface);\r\n  box-shadow: var(--dc-shadow-sm);\r\n}\r\n\r\n.doctor-tab-count {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 18px;\r\n  height: 18px;\r\n  padding: 0 5px;\r\n  border-radius: var(--dc-radius-pill);\r\n  color: var(--dc-primary);\r\n  background: var(--dc-primary-soft);\r\n  font-size: 10px;\r\n  font-weight: 800;\r\n}\r\n\r\n.doctor-tab.is-active .doctor-tab-count {\r\n  color: #ffffff;\r\n  background: var(--dc-primary);\r\n}\r\n\r\n.doctor-tab-dot,\r\n.doctor-dirty-dot {\r\n  display: inline-block;\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: #d97706;\r\n  box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.16);\r\n}\r\n\r\n.doctor-tab-panels {\r\n  min-width: 0;\r\n}\r\n\r\n.doctor-tab-panel {\r\n  min-width: 0;\r\n  animation: doctor-fade-in 180ms ease;\r\n}\r\n\r\n.doctor-count-badge {\r\n  flex-shrink: 0;\r\n  padding: 5px 10px;\r\n  border-radius: var(--dc-radius-pill);\r\n  color: var(--dc-primary);\r\n  background: var(--dc-primary-soft);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 750;\r\n  white-space: nowrap;\r\n}\r\n\r\n.doctor-unsaved-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-shrink: 0;\r\n  padding: 4px 9px;\r\n  border-radius: var(--dc-radius-pill);\r\n  color: #9a5b00;\r\n  background: var(--dc-warning-bg);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 700;\r\n}\r\n\r\n.doctor-inline-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--dc-space-2);\r\n  margin-bottom: var(--dc-space-3);\r\n  padding: 9px 11px;\r\n  border-radius: 9px;\r\n  color: var(--dc-muted);\r\n  background: var(--dc-surface-muted);\r\n  font-size: var(--dc-text-sm);\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Notes form\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-consultation-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: var(--dc-space-5);\r\n}\r\n\r\n.doctor-form-section {\r\n  min-width: 0;\r\n  margin: 0;\r\n  padding: 0;\r\n  border: 0;\r\n}\r\n\r\n.doctor-form-legend {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: var(--dc-space-2);\r\n  width: 100%;\r\n  margin-bottom: var(--dc-space-3);\r\n  padding: 0 0 var(--dc-space-2);\r\n  border-bottom: 1px solid var(--dc-line);\r\n  color: var(--dc-ink);\r\n  font-size: var(--dc-text-md);\r\n  font-weight: 700;\r\n}\r\n\r\n.doctor-form-step {\r\n  display: inline-grid;\r\n  place-items: center;\r\n  width: 22px;\r\n  height: 22px;\r\n  flex-shrink: 0;\r\n  border-radius: 50%;\r\n  color: var(--dc-primary);\r\n  background: var(--dc-primary-soft);\r\n  font-size: 11px;\r\n  font-weight: 800;\r\n}\r\n\r\n.doctor-form-legend-hint {\r\n  margin-left: auto;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-xs);\r\n  font-weight: 500;\r\n}\r\n\r\n.doctor-form-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 14px;\r\n}\r\n\r\n.doctor-form-grid--complaint {\r\n  grid-template-columns: minmax(0, 1.6fr) minmax(0, 0.9fr);\r\n}\r\n\r\n.doctor-form-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  min-width: 0;\r\n}\r\n\r\n.doctor-form-field--full {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.doctor-form-field label {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: var(--dc-ink-soft);\r\n  font-size: var(--dc-text-base);\r\n  font-weight: 650;\r\n}\r\n\r\n.doctor-required {\r\n  color: var(--dc-danger);\r\n  font-weight: 800;\r\n}\r\n\r\n.doctor-field-badge {\r\n  padding: 1px 6px;\r\n  border-radius: var(--dc-radius-pill);\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.doctor-field-badge--required {\r\n  color: var(--dc-danger);\r\n  background: var(--dc-danger-bg);\r\n}\r\n\r\n.doctor-form-field input,\r\n.doctor-form-field textarea {\r\n  width: 100%;\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--dc-line-strong);\r\n  border-radius: 10px;\r\n  color: var(--dc-ink);\r\n  background: var(--dc-surface);\r\n  font: inherit;\r\n  font-size: 13.5px;\r\n  line-height: 1.55;\r\n  transition:\r\n    border-color var(--dc-transition),\r\n    box-shadow var(--dc-transition),\r\n    background-color var(--dc-transition);\r\n}\r\n\r\n.doctor-form-field textarea {\r\n  min-height: 82px;\r\n  resize: vertical;\r\n}\r\n\r\n.doctor-form-field input::placeholder,\r\n.doctor-form-field textarea::placeholder {\r\n  color: #93a5b1;\r\n}\r\n\r\n.doctor-form-field input:hover,\r\n.doctor-form-field textarea:hover {\r\n  border-color: #aebfc9;\r\n}\r\n\r\n.doctor-form-field input:focus,\r\n.doctor-form-field textarea:focus {\r\n  outline: none;\r\n  border-color: var(--dc-primary);\r\n  box-shadow: var(--dc-focus-ring);\r\n}\r\n\r\n.doctor-field-hint {\r\n  color: var(--dc-muted);\r\n  font-size: 11.5px;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* Sticky save feedback bar */\r\n.doctor-save-bar {\r\n  position: sticky;\r\n  bottom: var(--dc-space-3);\r\n  z-index: 6;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: var(--dc-space-3);\r\n  margin-top: var(--dc-space-1);\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: var(--dc-radius-md);\r\n  background: rgba(255, 255, 255, 0.94);\r\n  box-shadow: 0 -6px 22px rgba(16, 32, 46, 0.08);\r\n  backdrop-filter: blur(8px);\r\n}\r\n\r\n.doctor-save-bar.is-dirty {\r\n  border-color: #f0d69b;\r\n}\r\n\r\n.doctor-save-state {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  min-width: 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-sm);\r\n  font-weight: 650;\r\n}\r\n\r\n.doctor-save-state svg {\r\n  width: 14px;\r\n  height: 14px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.doctor-save-state.is-saved {\r\n  color: var(--dc-success);\r\n}\r\n\r\n.doctor-save-state.is-dirty {\r\n  color: #9a5b00;\r\n}\r\n\r\n.doctor-save-state.is-error {\r\n  color: var(--dc-danger);\r\n}\r\n\r\n.doctor-save-button {\r\n  min-width: 132px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Test results\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-result-grid,\r\n.doctor-skeleton-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.doctor-result-card {\r\n  min-width: 0;\r\n  padding: 12px 14px;\r\n  border: 1px solid var(--dc-line);\r\n  border-left: 3px solid var(--dc-line-strong);\r\n  border-radius: 10px;\r\n  background: var(--dc-surface);\r\n  transition: box-shadow var(--dc-transition), border-color var(--dc-transition);\r\n}\r\n\r\n.doctor-result-card:hover {\r\n  box-shadow: var(--dc-shadow-sm);\r\n}\r\n\r\n.doctor-result-card.is-success {\r\n  border-left-color: var(--dc-primary);\r\n}\r\n\r\n.doctor-result-card.is-danger {\r\n  border-left-color: var(--dc-danger-strong);\r\n  background: #fffafa;\r\n}\r\n\r\n.doctor-result-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: var(--dc-space-2);\r\n}\r\n\r\n.doctor-result-header > div {\r\n  min-width: 0;\r\n}\r\n\r\n.doctor-result-header h3 {\r\n  margin: 0;\r\n  color: var(--dc-ink);\r\n  font-size: 13.5px;\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n}\r\n\r\n.doctor-result-code {\r\n  display: block;\r\n  margin-top: 2px;\r\n  color: var(--dc-muted);\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.doctor-result-status {\r\n  flex-shrink: 0;\r\n  padding: 3px 7px;\r\n  border-radius: 6px;\r\n  font-size: 9px;\r\n  font-weight: 800;\r\n  letter-spacing: 0.03em;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n}\r\n\r\n.doctor-result-status.is-success {\r\n  color: var(--dc-success);\r\n  background: var(--dc-success-bg);\r\n}\r\n\r\n.doctor-result-status.is-neutral {\r\n  color: var(--dc-muted);\r\n  background: var(--dc-surface-muted);\r\n}\r\n\r\n.doctor-result-value {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n  margin-top: 9px;\r\n}\r\n\r\n.doctor-result-value strong {\r\n  color: var(--dc-ink);\r\n  font-size: 20px;\r\n  font-weight: 750;\r\n  line-height: 1.1;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.doctor-result-value > span {\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-sm);\r\n}\r\n\r\n.doctor-result-value > .doctor-result-flag {\r\n  color: var(--dc-danger);\r\n  font-size: 10px;\r\n}\r\n\r\n.doctor-result-flag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 3px;\r\n  padding: 2px 7px;\r\n  border-radius: var(--dc-radius-pill);\r\n  color: var(--dc-danger);\r\n  background: var(--dc-danger-bg);\r\n  font-size: 10px;\r\n  font-weight: 750;\r\n}\r\n\r\n.doctor-result-flag svg {\r\n  width: 11px;\r\n  height: 11px;\r\n}\r\n\r\n.doctor-result-remarks {\r\n  margin: 9px 0 0;\r\n  padding-top: 8px;\r\n  border-top: 1px dashed var(--dc-line);\r\n  color: var(--dc-muted);\r\n  font-size: 11.5px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.doctor-result-remarks strong {\r\n  display: block;\r\n  margin-bottom: 1px;\r\n  color: var(--dc-ink-soft);\r\n  font-size: 10px;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Underwriting\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-underwriting-summary {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 10px;\r\n  margin: 0 0 var(--dc-space-3);\r\n}\r\n\r\n.doctor-underwriting-summary > div {\r\n  min-width: 0;\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: 10px;\r\n  background: var(--dc-surface-muted);\r\n}\r\n\r\n.doctor-underwriting-summary dt {\r\n  margin-bottom: 3px;\r\n  color: var(--dc-muted);\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.doctor-underwriting-summary dd {\r\n  margin: 0;\r\n  color: var(--dc-ink-soft);\r\n  font-size: var(--dc-text-base);\r\n  font-weight: 700;\r\n}\r\n\r\n.doctor-underwriting-groups {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 10px;\r\n}\r\n\r\n.doctor-underwriting-group {\r\n  min-width: 0;\r\n  padding: 11px 13px;\r\n  border: 1px solid var(--dc-line);\r\n  border-left: 3px solid var(--dc-primary);\r\n  border-radius: 10px;\r\n  background: var(--dc-surface);\r\n}\r\n\r\n.doctor-underwriting-group h4 {\r\n  margin: 0 0 8px;\r\n  color: var(--dc-ink);\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n}\r\n\r\n.doctor-underwriting-facts {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 7px 12px;\r\n  margin: 0;\r\n}\r\n\r\n.doctor-underwriting-facts > div {\r\n  min-width: 0;\r\n}\r\n\r\n.doctor-underwriting-facts dt {\r\n  margin-bottom: 1px;\r\n  color: var(--dc-muted);\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.03em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.doctor-underwriting-facts dd {\r\n  margin: 0;\r\n  color: var(--dc-ink-soft);\r\n  font-size: var(--dc-text-sm);\r\n  font-weight: 650;\r\n}\r\n\r\n.doctor-underwriting-facts dd.is-flagged,\r\n.doctor-underwriting-summary dd.is-flagged {\r\n  color: var(--dc-danger);\r\n  font-weight: 750;\r\n}\r\n\r\n.doctor-underwriting-facts dd.is-normal,\r\n.doctor-underwriting-summary dd.is-normal {\r\n  color: var(--dc-success);\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Empty, skeleton and state cards\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-empty-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 4px;\r\n  padding: var(--dc-space-7) var(--dc-space-5);\r\n  border: 1px dashed var(--dc-line-strong);\r\n  border-radius: var(--dc-radius-md);\r\n  background: var(--dc-surface-muted);\r\n  text-align: center;\r\n}\r\n\r\n.doctor-empty-state-icon {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 48px;\r\n  height: 48px;\r\n  margin-bottom: var(--dc-space-2);\r\n  border-radius: 50%;\r\n  color: var(--dc-primary);\r\n  background: var(--dc-primary-soft);\r\n}\r\n\r\n.doctor-empty-state-icon svg {\r\n  width: 22px;\r\n  height: 22px;\r\n}\r\n\r\n.doctor-empty-state h3 {\r\n  margin: 0;\r\n  color: var(--dc-ink);\r\n  font-size: var(--dc-text-md);\r\n  font-weight: 700;\r\n}\r\n\r\n.doctor-empty-state p {\r\n  max-width: 330px;\r\n  margin: 2px 0 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-sm);\r\n  line-height: 1.6;\r\n}\r\n\r\n.doctor-skeleton-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 9px;\r\n  padding: 14px;\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: 10px;\r\n  background: var(--dc-surface);\r\n}\r\n\r\n.doctor-skeleton-line {\r\n  display: block;\r\n  width: 100%;\r\n  height: 10px;\r\n  border-radius: var(--dc-radius-pill);\r\n  background: linear-gradient(90deg, #e8eef2 25%, #f7fafb 37%, #e8eef2 63%);\r\n  background-size: 400% 100%;\r\n  animation: doctor-shimmer 1.4s ease infinite;\r\n}\r\n\r\n.doctor-skeleton-line.is-short {\r\n  width: 52%;\r\n}\r\n\r\n.doctor-skeleton-line.is-value {\r\n  width: 36%;\r\n  height: 18px;\r\n}\r\n\r\n.doctor-page-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: var(--dc-space-3);\r\n  min-height: 62vh;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-md);\r\n}\r\n\r\n.doctor-page-loading p {\r\n  margin: 0;\r\n}\r\n\r\n.doctor-state-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: var(--dc-space-2);\r\n  max-width: 560px;\r\n  margin: clamp(24px, 8vh, 90px) auto 0;\r\n  padding: var(--dc-space-7) var(--dc-space-6);\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: var(--dc-radius-xl);\r\n  background: var(--dc-surface);\r\n  box-shadow: var(--dc-shadow-md);\r\n  text-align: center;\r\n}\r\n\r\n.doctor-state-icon {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 60px;\r\n  height: 60px;\r\n  margin-bottom: var(--dc-space-2);\r\n  border-radius: 50%;\r\n}\r\n\r\n.doctor-state-icon svg {\r\n  width: 26px;\r\n  height: 26px;\r\n}\r\n\r\n.doctor-state-icon--success {\r\n  color: var(--dc-success);\r\n  background: var(--dc-success-bg);\r\n}\r\n\r\n.doctor-state-icon--danger {\r\n  color: var(--dc-danger);\r\n  background: var(--dc-danger-bg);\r\n}\r\n\r\n.doctor-state-card h1 {\r\n  margin: 0;\r\n  font-size: var(--dc-text-2xl);\r\n  font-weight: 700;\r\n  line-height: 1.2;\r\n}\r\n\r\n.doctor-state-card > p {\r\n  max-width: 400px;\r\n  margin: 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-md);\r\n  line-height: 1.6;\r\n}\r\n\r\n.doctor-state-card > p strong {\r\n  color: var(--dc-ink-soft);\r\n}\r\n\r\n.doctor-state-card .doctor-button {\r\n  margin-top: var(--dc-space-3);\r\n}\r\n\r\n.doctor-state-details {\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: var(--dc-space-2);\r\n  width: 100%;\r\n  max-width: 360px;\r\n  margin: var(--dc-space-3) 0 var(--dc-space-1);\r\n}\r\n\r\n.doctor-state-details > div {\r\n  padding: 10px 14px;\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: 10px;\r\n  background: var(--dc-surface-muted);\r\n}\r\n\r\n.doctor-state-details dt {\r\n  margin-bottom: 2px;\r\n  color: var(--dc-muted);\r\n  font-size: 10px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.04em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.doctor-state-details dd {\r\n  margin: 0;\r\n  color: var(--dc-ink-soft);\r\n  font-size: var(--dc-text-md);\r\n  font-weight: 700;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   End-call modal\r\n   -------------------------------------------------------------------------- */\r\n\r\n.doctor-modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  display: grid;\r\n  place-items: center;\r\n  padding: var(--dc-space-5);\r\n  background: rgba(7, 20, 28, 0.56);\r\n  backdrop-filter: blur(4px);\r\n  animation: doctor-fade-in 160ms ease;\r\n}\r\n\r\n.doctor-modal {\r\n  width: min(440px, 100%);\r\n  padding: var(--dc-space-6);\r\n  border: 1px solid var(--dc-line);\r\n  border-radius: var(--dc-radius-xl);\r\n  background: var(--dc-surface);\r\n  box-shadow: var(--dc-shadow-lg);\r\n  animation: doctor-pop-in 200ms ease;\r\n}\r\n\r\n.doctor-modal-icon {\r\n  display: grid;\r\n  place-items: center;\r\n  width: 52px;\r\n  height: 52px;\r\n  margin-bottom: var(--dc-space-3);\r\n  border-radius: 50%;\r\n  color: var(--dc-danger);\r\n  background: var(--dc-danger-bg);\r\n}\r\n\r\n.doctor-modal-icon svg {\r\n  width: 23px;\r\n  height: 23px;\r\n}\r\n\r\n.doctor-modal h2 {\r\n  margin: 0 0 var(--dc-space-2);\r\n  font-size: var(--dc-text-xl);\r\n  font-weight: 700;\r\n  line-height: 1.3;\r\n}\r\n\r\n.doctor-modal > p {\r\n  margin: 0;\r\n  color: var(--dc-muted);\r\n  font-size: var(--dc-text-md);\r\n  line-height: 1.6;\r\n}\r\n\r\n.doctor-modal > p strong {\r\n  color: var(--dc-ink-soft);\r\n}\r\n\r\n.doctor-modal .doctor-alert {\r\n  margin-top: var(--dc-space-3);\r\n}\r\n\r\n.doctor-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: var(--dc-space-2);\r\n  margin-top: var(--dc-space-5);\r\n}\r\n\r\n/* --------------------------------------------------------------------------\r\n   Responsive\r\n   -------------------------------------------------------------------------- */\r\n\r\n@media (max-width: 1200px) {\r\n  .doctor-live-layout {\r\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\r\n  }\r\n\r\n  .doctor-info-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n\r\n  .doctor-underwriting-summary {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .doctor-live-layout {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .doctor-live-sidebar,\r\n  .doctor-waiting-card {\r\n    position: static;\r\n  }\r\n\r\n  .doctor-video-stage {\r\n    max-height: 62vh;\r\n  }\r\n\r\n  .doctor-tabs {\r\n    top: var(--dc-space-2);\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .doctor-waiting-layout {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .doctor-waiting-card {\r\n    padding: var(--dc-space-6);\r\n  }\r\n\r\n  .doctor-form-grid,\r\n  .doctor-form-grid--complaint {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .doctor-underwriting-groups {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .doctor-underwriting-facts {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n}\r\n\r\n@media (max-width: 700px) {\r\n  .doctor-call-page {\r\n    padding: var(--dc-space-3) var(--dc-space-3) var(--dc-space-7);\r\n  }\r\n\r\n  .doctor-page-header {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    gap: var(--dc-space-2);\r\n  }\r\n\r\n  .doctor-page-heading {\r\n    width: 100%;\r\n  }\r\n\r\n  .doctor-page-heading h1 {\r\n    font-size: var(--dc-text-xl);\r\n  }\r\n\r\n  .doctor-status-badge {\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .doctor-patient-bar {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .doctor-patient-flags {\r\n    width: 100%;\r\n  }\r\n\r\n  .doctor-result-grid,\r\n  .doctor-skeleton-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .doctor-video-panel,\r\n  .doctor-notes-panel {\r\n    padding: 10px;\r\n  }\r\n\r\n  .doctor-video-stage {\r\n    aspect-ratio: 4 / 3;\r\n  }\r\n\r\n  .doctor-call-controls {\r\n    gap: var(--dc-space-5);\r\n  }\r\n\r\n  .doctor-control-button {\r\n    width: 58px;\r\n    height: 58px;\r\n    min-height: 58px;\r\n  }\r\n\r\n  .doctor-modal-actions {\r\n    flex-direction: column-reverse;\r\n  }\r\n\r\n  .doctor-modal-actions .doctor-button {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 560px) {\r\n  .doctor-tabs {\r\n    display: flex;\r\n    gap: 3px;\r\n    overflow-x: auto;\r\n    padding: 3px;\r\n    scrollbar-width: none;\r\n  }\r\n\r\n  .doctor-tabs::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n\r\n  .doctor-tab {\r\n    flex: 1 0 auto;\r\n    min-height: 44px;\r\n    padding: 0 10px;\r\n    font-size: var(--dc-text-xs);\r\n  }\r\n\r\n  .doctor-tab svg {\r\n    display: none;\r\n  }\r\n\r\n  .doctor-info-card {\r\n    padding: var(--dc-space-4);\r\n  }\r\n\r\n  .doctor-info-grid,\r\n  .doctor-state-details {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .doctor-form-legend-hint {\r\n    display: none;\r\n  }\r\n\r\n  .doctor-save-bar {\r\n    align-items: stretch;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .doctor-save-button {\r\n    width: 100%;\r\n  }\r\n\r\n  .doctor-video-overlay-top {\r\n    top: 9px;\r\n    left: 9px;\r\n    right: 9px;\r\n  }\r\n\r\n  .doctor-room-chip {\r\n    max-width: 48%;\r\n  }\r\n\r\n  .doctor-local-video-wrap {\r\n    right: 9px;\r\n    bottom: 9px;\r\n    width: 32%;\r\n  }\r\n\r\n  .doctor-underwriting-summary {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .doctor-state-card {\r\n    padding: var(--dc-space-6) var(--dc-space-4);\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .doctor-call-page *,\r\n  .doctor-call-page *::before,\r\n  .doctor-call-page *::after {\r\n    animation-duration: 0.001ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.001ms !important;\r\n    scroll-behavior: auto !important;\r\n  }\r\n}\r\n\r\n/* ==========================================================================\r\n   DOCTOR TELECONSULTATIONS LIST PAGE (shared stylesheet)\r\n   ========================================================================== */\r\n\r\n.doctor-tele-page {\r\n  min-height: 100vh;\r\n  padding: 32px;\r\n  background: #f5f8fa;\r\n  box-sizing: border-box;\r\n  font-family:\r\n    Inter,\r\n    -apple-system,\r\n    BlinkMacSystemFont,\r\n    \"Segoe UI\",\r\n    Roboto,\r\n    Arial,\r\n    sans-serif;\r\n  color: #1f2937;\r\n}\r\n\r\n.doctor-tele-header {\r\n  max-width: 1200px;\r\n  margin: 0 auto 28px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 24px;\r\n}\r\n\r\n.doctor-tele-title-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.doctor-page-icon {\r\n  width: 52px;\r\n  height: 52px;\r\n  border-radius: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #e7f7f6;\r\n  color: #0f9f9a;\r\n  font-size: 25px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.doctor-tele-header h1 {\r\n  margin: 0;\r\n  font-size: 28px;\r\n  line-height: 1.25;\r\n  font-weight: 700;\r\n  color: #17212b;\r\n}\r\n\r\n.doctor-tele-header p {\r\n  margin: 6px 0 0;\r\n  font-size: 14px;\r\n  color: #718096;\r\n}\r\n\r\n.doctor-refresh-button {\r\n  height: 42px;\r\n  padding: 0 18px;\r\n  border: 1px solid #d6e2e8;\r\n  border-radius: 9px;\r\n  background: #ffffff;\r\n  color: #334155;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  transition:\r\n    background 0.2s ease,\r\n    border-color 0.2s ease,\r\n    box-shadow 0.2s ease;\r\n}\r\n\r\n.doctor-refresh-button:hover:not(:disabled) {\r\n  background: #f8fafc;\r\n  border-color: #b8cbd4;\r\n  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.06);\r\n}\r\n\r\n.doctor-refresh-button:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.refresh-icon {\r\n  font-size: 20px;\r\n  line-height: 1;\r\n}\r\n\r\n.refresh-icon.spinning {\r\n  animation: refresh-spin 0.9s linear infinite;\r\n}\r\n\r\n@keyframes refresh-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.doctor-loading-container {\r\n  min-height: 70vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #64748b;\r\n}\r\n\r\n.doctor-loading-container p {\r\n  margin: 14px 0 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.doctor-spinner {\r\n  width: 36px;\r\n  height: 36px;\r\n  border: 3px solid #dceceb;\r\n  border-top-color: #11a8a4;\r\n  border-radius: 50%;\r\n  animation: doctor-spinner-animation 0.8s linear infinite;\r\n}\r\n\r\n@keyframes doctor-spinner-animation {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.doctor-error {\r\n  max-width: 1200px;\r\n  margin: 0 auto 20px;\r\n  padding: 13px 16px;\r\n  border: 1px solid #fecaca;\r\n  border-radius: 9px;\r\n  background: #fff5f5;\r\n  color: #b42318;\r\n  font-size: 14px;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.error-icon {\r\n  width: 22px;\r\n  height: 22px;\r\n  border-radius: 50%;\r\n  background: #fee2e2;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.doctor-consultation-list {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  gap: 20px;\r\n}\r\n\r\n.doctor-consultation-card {\r\n  background: #ffffff;\r\n  border: 1px solid #e3eaee;\r\n  border-radius: 14px;\r\n  overflow: hidden;\r\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\r\n  transition:\r\n    transform 0.2s ease,\r\n    box-shadow 0.2s ease,\r\n    border-color 0.2s ease;\r\n}\r\n\r\n.doctor-consultation-card:hover {\r\n  transform: translateY(-2px);\r\n  border-color: #c9dddd;\r\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\r\n}\r\n\r\n.consultation-card-top {\r\n  padding: 20px 20px 18px;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  border-bottom: 1px solid #edf2f4;\r\n}\r\n\r\n.patient-heading {\r\n  min-width: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 13px;\r\n}\r\n\r\n.patient-avatar {\r\n  width: 46px;\r\n  height: 46px;\r\n  border-radius: 12px;\r\n  background: #e7f7f6;\r\n  color: #0f9f9a;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.patient-heading h2 {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  line-height: 1.35;\r\n  font-weight: 700;\r\n  color: #17212b;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.patient-heading p {\r\n  margin: 4px 0 0;\r\n  font-size: 12px;\r\n  color: #7b8794;\r\n}\r\n\r\n.status-badge {\r\n  min-height: 28px;\r\n  padding: 5px 10px;\r\n  border-radius: 20px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.3px;\r\n  white-space: nowrap;\r\n}\r\n\r\n.status-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n}\r\n\r\n.status-waiting {\r\n  background: #fff7df;\r\n  color: #996c00;\r\n}\r\n\r\n.status-waiting .status-dot {\r\n  background: #d99a00;\r\n}\r\n\r\n.status-ongoing {\r\n  background: #e5f8ef;\r\n  color: #137a4a;\r\n}\r\n\r\n.status-ongoing .status-dot {\r\n  background: #16a05d;\r\n}\r\n\r\n.status-completed {\r\n  background: #eef2f6;\r\n  color: #64748b;\r\n}\r\n\r\n.status-completed .status-dot {\r\n  background: #64748b;\r\n}\r\n\r\n.status-cancelled {\r\n  background: #fff0f0;\r\n  color: #b42318;\r\n}\r\n\r\n.status-cancelled .status-dot {\r\n  background: #d92d20;\r\n}\r\n\r\n.status-unknown {\r\n  background: #f1f5f9;\r\n  color: #64748b;\r\n}\r\n\r\n.status-unknown .status-dot {\r\n  background: #94a3b8;\r\n}\r\n\r\n.consultation-info-grid {\r\n  padding: 18px 20px;\r\n  display: grid;\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  column-gap: 22px;\r\n  row-gap: 17px;\r\n}\r\n\r\n.consultation-info-item {\r\n  min-width: 0;\r\n}\r\n\r\n.consultation-info-item span {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: #8a98a6;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.45px;\r\n}\r\n\r\n.consultation-info-item strong {\r\n  display: block;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #334155;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.consultation-card-actions {\r\n  padding: 0 20px 20px;\r\n}\r\n\r\n.consultation-open-button {\r\n  width: 100%;\r\n  height: 43px;\r\n  border: none;\r\n  border-radius: 9px;\r\n  background: #11a8a4;\r\n  color: #ffffff;\r\n  font-size: 13px;\r\n  font-weight: 700;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 0 15px;\r\n  transition:\r\n    background 0.2s ease,\r\n    transform 0.2s ease,\r\n    box-shadow 0.2s ease;\r\n}\r\n\r\n.consultation-open-button:hover {\r\n  background: #0d918e;\r\n  box-shadow: 0 4px 12px rgba(17, 168, 164, 0.2);\r\n}\r\n\r\n.consultation-open-button:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.consultation-open-button.button-ongoing {\r\n  background: #168653;\r\n}\r\n\r\n.consultation-open-button.button-ongoing:hover {\r\n  background: #117344;\r\n}\r\n\r\n.button-arrow {\r\n  font-size: 19px;\r\n  line-height: 1;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.consultation-open-button:hover .button-arrow {\r\n  transform: translateX(3px);\r\n}\r\n\r\n.doctor-empty {\r\n  max-width: 600px;\r\n  margin: 70px auto;\r\n  padding: 45px 30px;\r\n  text-align: center;\r\n  background: #ffffff;\r\n  border: 1px solid #e3eaee;\r\n  border-radius: 14px;\r\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.doctor-empty-icon {\r\n  width: 60px;\r\n  height: 60px;\r\n  margin: 0 auto 18px;\r\n  border-radius: 50%;\r\n  background: #e7f7f6;\r\n  color: #11a8a4;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 27px;\r\n}\r\n\r\n.doctor-empty h3 {\r\n  margin: 0;\r\n  font-size: 19px;\r\n  font-weight: 700;\r\n  color: #273444;\r\n}\r\n\r\n.doctor-empty p {\r\n  max-width: 420px;\r\n  margin: 8px auto 22px;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n  color: #7b8794;\r\n}\r\n\r\n.doctor-empty-refresh {\r\n  height: 40px;\r\n  padding: 0 18px;\r\n  border: 1px solid #cfe4e3;\r\n  border-radius: 8px;\r\n  background: #ffffff;\r\n  color: #0f918e;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.doctor-empty-refresh:hover:not(:disabled) {\r\n  background: #f0fbfa;\r\n}\r\n\r\n.doctor-empty-refresh:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.doctor-header-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: stretch;\r\n  gap: 9px;\r\n  min-width: 145px;\r\n}\r\n\r\n.doctor-logout-button {\r\n  width: 100%;\r\n  height: 42px;\r\n  padding: 0 18px;\r\n  border: 1px solid #f1caca;\r\n  border-radius: 9px;\r\n  background: #ffffff;\r\n  color: #c0392b;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  transition:\r\n    background 0.2s ease,\r\n    border-color 0.2s ease,\r\n    box-shadow 0.2s ease,\r\n    color 0.2s ease;\r\n}\r\n\r\n.doctor-logout-button:hover {\r\n  background: #fff5f5;\r\n  border-color: #e7a9a9;\r\n  color: #b42318;\r\n  box-shadow: 0 2px 7px rgba(180, 35, 24, 0.08);\r\n}\r\n\r\n.doctor-logout-button:active {\r\n  transform: translateY(1px);\r\n}\r\n\r\n.logout-icon {\r\n  font-size: 18px;\r\n  line-height: 1;\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .doctor-tele-page {\r\n    padding: 24px;\r\n  }\r\n\r\n  .doctor-consultation-list {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .doctor-tele-page {\r\n    padding: 16px;\r\n  }\r\n\r\n  .doctor-tele-header {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .doctor-tele-title-section {\r\n    width: 100%;\r\n  }\r\n\r\n  .doctor-page-icon {\r\n    width: 46px;\r\n    height: 46px;\r\n    font-size: 21px;\r\n  }\r\n\r\n  .doctor-tele-header h1 {\r\n    font-size: 23px;\r\n  }\r\n\r\n  .doctor-tele-header p {\r\n    font-size: 13px;\r\n    line-height: 1.5;\r\n  }\r\n\r\n  .doctor-refresh-button {\r\n    width: 100%;\r\n  }\r\n\r\n  .consultation-card-top {\r\n    padding: 16px;\r\n    flex-direction: column;\r\n  }\r\n\r\n  .patient-heading {\r\n    width: 100%;\r\n  }\r\n\r\n  .patient-heading h2 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .status-badge {\r\n    align-self: flex-start;\r\n  }\r\n\r\n  .consultation-info-grid {\r\n    padding: 16px;\r\n    grid-template-columns: 1fr;\r\n    row-gap: 14px;\r\n  }\r\n\r\n  .consultation-card-actions {\r\n    padding: 0 16px 16px;\r\n  }\r\n\r\n  .doctor-empty {\r\n    margin: 40px auto;\r\n    padding: 35px 20px;\r\n  }\r\n\r\n  .doctor-header-actions {\r\n    width: 100%;\r\n    min-width: 0;\r\n  }\r\n\r\n  .doctor-refresh-button,\r\n  .doctor-logout-button {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n  .doctor-tele-page {\r\n    padding: 12px;\r\n  }\r\n\r\n  .doctor-tele-title-section {\r\n    gap: 10px;\r\n  }\r\n\r\n  .doctor-tele-header h1 {\r\n    font-size: 21px;\r\n  }\r\n\r\n  .doctor-page-icon {\r\n    width: 42px;\r\n    height: 42px;\r\n    border-radius: 11px;\r\n  }\r\n\r\n  .patient-avatar {\r\n    width: 42px;\r\n    height: 42px;\r\n  }\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
